var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _g, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 521,
    height: 388,
    viewBox: "0 0 521 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.989 340.511H0.98877V340.771H520.989V340.511Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468.884 357.245H434.439V357.505H468.884V357.245Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.458 360.073H336.42V360.333H345.458V360.073Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.4 347.594H413.442V347.854H433.4V347.594Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.465 349.341H55.5474V349.601H100.465V349.341Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.314 349.341H109.731V349.601H116.314V349.341Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.145 353.729H137.718V353.99H235.145V353.729Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.469 294.127H46.6551C45.0819 294.124 43.5741 293.497 42.4627 292.384C41.3513 291.271 40.727 289.762 40.7271 288.189V5.90154C40.7407 4.3374 41.371 2.84183 42.481 1.73968C43.5909 0.637533 45.0909 0.0178162 46.6551 0.0151367H247.469C249.044 0.0151367 250.554 0.640788 251.668 1.75445C252.781 2.86812 253.407 4.37857 253.407 5.95354V288.189C253.407 289.764 252.781 291.274 251.668 292.388C250.554 293.501 249.044 294.127 247.469 294.127ZM46.6551 0.223137C45.1508 0.225892 43.7092 0.825364 42.6465 1.88997C41.5839 2.95458 40.987 4.39733 40.9871 5.90154V288.189C40.987 289.693 41.5839 291.136 42.6465 292.2C43.7092 293.265 45.1508 293.864 46.6551 293.867H247.469C248.974 293.864 250.417 293.265 251.481 292.201C252.545 291.137 253.144 289.694 253.147 288.189V5.90154C253.144 4.39638 252.545 2.95365 251.481 1.88934C250.417 0.825027 248.974 0.225887 247.469 0.223137H46.6551Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M472.431 294.127H271.607C270.033 294.124 268.524 293.498 267.411 292.385C266.298 291.272 265.672 289.763 265.669 288.189V5.90154C265.685 4.33645 266.318 2.8409 267.43 1.73903C268.541 0.63717 270.042 0.0177869 271.607 0.0151367H472.431C473.994 0.0205494 475.491 0.641476 476.599 1.74333C477.706 2.84519 478.335 4.3392 478.349 5.90154V288.189C478.349 289.76 477.726 291.267 476.617 292.38C475.508 293.494 474.003 294.122 472.431 294.127ZM271.607 0.223137C270.102 0.225887 268.659 0.825027 267.595 1.88934C266.531 2.95365 265.932 4.39638 265.929 5.90154V288.189C265.932 289.694 266.531 291.137 267.595 292.201C268.659 293.265 270.102 293.864 271.607 293.867H472.431C473.936 293.864 475.379 293.265 476.444 292.201C477.508 291.137 478.107 289.694 478.11 288.189V5.90154C478.107 4.39638 477.508 2.95365 476.444 1.88934C475.379 0.825027 473.936 0.225887 472.431 0.223137H271.607Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M464.225 64.6824H212.254V307.564H464.225V64.6824Z",
    fill: "#D2DEED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M464.225 69.092H216.3V303.321H464.225V69.092Z",
    fill: "#EBF5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.13 246.599V176.139H225.441V166.831L241.915 159.135V149.609H244.661V176.139H247.406V246.599H251.067V209.991H259.304V190.782H262.049V246.599H268.445V225.549H273.021V220.058H283.089V200.849H288.58V188.037H294.986V168.817H297.732V188.037H304.138V200.849H309.619V220.058H319.686V225.549H324.262V246.599H329.753V220.058H339.821V161.506H342.566V155.1H364.521V161.506H369.097V203.595H387.401V208.161H393.797V210.906H387.401V227.38H406.609V172.478H410.27V161.506H419.422V119.417H422.168V161.506H428.574V172.478H464.225V303.321H216.3V246.599H218.13Z",
    fill: "#CDE2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 175.349H442.583V177.938H445.173V175.349Z",
    fill: "#EBF5FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 179.696H442.583V182.285H445.173V179.696Z",
    fill: "#EBF5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 197.085H442.583V199.674H445.173V197.085Z",
    fill: "#EBF5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 201.422H442.583V204.011H445.173V201.422Z",
    fill: "#EBF5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 205.769H442.583V208.358H445.173V205.769Z",
    fill: "#EBF5FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 218.81H442.583V221.4H445.173V218.81Z",
    fill: "#EBF5FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M445.173 223.157H442.583V225.747H445.173V223.157Z",
    fill: "#EBF5FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 192.738H438.465V195.327H441.054V192.738Z",
    fill: "#EBF5FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 197.084H438.465V199.674H441.054V197.084Z",
    fill: "#EBF5FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 201.422H438.465V204.011H441.054V201.422Z",
    fill: "#EBF5FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 205.769H438.465V208.358H441.054V205.769Z",
    fill: "#EBF5FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 210.116H438.465V212.705H441.054V210.116Z",
    fill: "#EBF5FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 218.81H438.465V221.4H441.054V218.81Z",
    fill: "#EBF5FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M441.054 223.157H438.465V225.747H441.054V223.157Z",
    fill: "#EBF5FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 175.349H434.347V177.938H436.936V175.349Z",
    fill: "#EBF5FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 179.696H434.347V182.285H436.936V179.696Z",
    fill: "#EBF5FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 184.043H434.347V186.633H436.936V184.043Z",
    fill: "#EBF5FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 188.39H434.347V190.98H436.936V188.39Z",
    fill: "#EBF5FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 192.738H434.347V195.327H436.936V192.738Z",
    fill: "#EBF5FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 197.085H434.347V199.674H436.936V197.085Z",
    fill: "#EBF5FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 201.422H434.347V204.011H436.936V201.422Z",
    fill: "#EBF5FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 205.769H434.347V208.358H436.936V205.769Z",
    fill: "#EBF5FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 210.116H434.347V212.706H436.936V210.116Z",
    fill: "#EBF5FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 214.463H434.347V217.053H436.936V214.463Z",
    fill: "#EBF5FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 223.157H434.347V225.747H436.936V223.157Z",
    fill: "#EBF5FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 175.349H430.228V177.938H432.818V175.349Z",
    fill: "#EBF5FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 179.696H430.228V182.285H432.818V179.696Z",
    fill: "#EBF5FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 184.043H430.228V186.633H432.818V184.043Z",
    fill: "#EBF5FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 188.39H430.228V190.98H432.818V188.39Z",
    fill: "#EBF5FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 192.738H430.228V195.327H432.818V192.738Z",
    fill: "#EBF5FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 197.084H430.228V199.674H432.818V197.084Z",
    fill: "#EBF5FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 201.422H430.228V204.011H432.818V201.422Z",
    fill: "#EBF5FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M432.818 240.546H430.228V243.136H432.818V240.546Z",
    fill: "#EBF5FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 175.349H426.11V177.938H428.699V175.349Z",
    fill: "#EBF5FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 179.696H426.11V182.285H428.699V179.696Z",
    fill: "#EBF5FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 184.043H426.11V186.633H428.699V184.043Z",
    fill: "#EBF5FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 188.39H426.11V190.98H428.699V188.39Z",
    fill: "#EBF5FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 192.738H426.11V195.327H428.699V192.738Z",
    fill: "#EBF5FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 197.084H426.11V199.674H428.699V197.084Z",
    fill: "#EBF5FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 201.422H426.11V204.011H428.699V201.422Z",
    fill: "#EBF5FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 205.769H426.11V208.358H428.699V205.769Z",
    fill: "#EBF5FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 231.852H426.11V234.442H428.699V231.852Z",
    fill: "#EBF5FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 236.199H426.11V238.789H428.699V236.199Z",
    fill: "#EBF5FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 240.546H426.11V243.136H428.699V240.546Z",
    fill: "#EBF5FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 244.883H426.11V247.473H428.699V244.883Z",
    fill: "#EBF5FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M428.699 262.272H426.11V264.862H428.699V262.272Z",
    fill: "#EBF5FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 175.349H421.991V177.938H424.58V175.349Z",
    fill: "#EBF5FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 179.696H421.991V182.285H424.58V179.696Z",
    fill: "#EBF5FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 184.043H421.991V186.633H424.58V184.043Z",
    fill: "#EBF5FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 188.39H421.991V190.98H424.58V188.39Z",
    fill: "#EBF5FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 192.738H421.991V195.327H424.58V192.738Z",
    fill: "#EBF5FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 197.084H421.991V199.674H424.58V197.084Z",
    fill: "#EBF5FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 201.422H421.991V204.011H424.58V201.422Z",
    fill: "#EBF5FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 205.769H421.991V208.358H424.58V205.769Z",
    fill: "#EBF5FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 210.116H421.991V212.705H424.58V210.116Z",
    fill: "#EBF5FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 214.463H421.991V217.053H424.58V214.463Z",
    fill: "#EBF5FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 227.505H421.991V230.094H424.58V227.505Z",
    fill: "#EBF5FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 231.852H421.991V234.442H424.58V231.852Z",
    fill: "#EBF5FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 236.199H421.991V238.789H424.58V236.199Z",
    fill: "#EBF5FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 240.546H421.991V243.136H424.58V240.546Z",
    fill: "#EBF5FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 244.883H421.991V247.473H424.58V244.883Z",
    fill: "#EBF5FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M424.58 262.272H421.991V264.862H424.58V262.272Z",
    fill: "#EBF5FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 175.349H417.873V177.938H420.462V175.349Z",
    fill: "#EBF5FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 179.696H417.873V182.285H420.462V179.696Z",
    fill: "#EBF5FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 184.043H417.873V186.633H420.462V184.043Z",
    fill: "#EBF5FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 188.39H417.873V190.98H420.462V188.39Z",
    fill: "#EBF5FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 192.738H417.873V195.327H420.462V192.738Z",
    fill: "#EBF5FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 197.085H417.873V199.674H420.462V197.085Z",
    fill: "#EBF5FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 201.422H417.873V204.011H420.462V201.422Z",
    fill: "#EBF5FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 205.769H417.873V208.358H420.462V205.769Z",
    fill: "#EBF5FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 210.116H417.873V212.706H420.462V210.116Z",
    fill: "#EBF5FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 214.463H417.873V217.053H420.462V214.463Z",
    fill: "#EBF5FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 218.81H417.873V221.4H420.462V218.81Z",
    fill: "#EBF5FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 223.157H417.873V225.747H420.462V223.157Z",
    fill: "#EBF5FF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 227.505H417.873V230.094H420.462V227.505Z",
    fill: "#EBF5FF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 231.852H417.873V234.441H420.462V231.852Z",
    fill: "#EBF5FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 236.199H417.873V238.789H420.462V236.199Z",
    fill: "#EBF5FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 240.546H417.873V243.136H420.462V240.546Z",
    fill: "#EBF5FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 244.883H417.873V247.473H420.462V244.883Z",
    fill: "#EBF5FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M420.462 249.23H417.873V251.82H420.462V249.23Z",
    fill: "#EBF5FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 175.349H413.754V177.938H416.344V175.349Z",
    fill: "#EBF5FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 179.696H413.754V182.285H416.344V179.696Z",
    fill: "#EBF5FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 184.043H413.754V186.633H416.344V184.043Z",
    fill: "#EBF5FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 188.39H413.754V190.98H416.344V188.39Z",
    fill: "#EBF5FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 192.738H413.754V195.327H416.344V192.738Z",
    fill: "#EBF5FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 197.084H413.754V199.674H416.344V197.084Z",
    fill: "#EBF5FF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 201.422H413.754V204.011H416.344V201.422Z",
    fill: "#EBF5FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 205.769H413.754V208.358H416.344V205.769Z",
    fill: "#EBF5FF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 210.116H413.754V212.705H416.344V210.116Z",
    fill: "#EBF5FF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 214.463H413.754V217.053H416.344V214.463Z",
    fill: "#EBF5FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 227.505H413.754V230.094H416.344V227.505Z",
    fill: "#EBF5FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 231.852H413.754V234.442H416.344V231.852Z",
    fill: "#EBF5FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 236.199H413.754V238.789H416.344V236.199Z",
    fill: "#EBF5FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M416.344 240.546H413.754V243.136H416.344V240.546Z",
    fill: "#EBF5FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 175.349H409.646V177.938H412.236V175.349Z",
    fill: "#EBF5FF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 179.696H409.646V182.285H412.236V179.696Z",
    fill: "#EBF5FF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 184.043H409.646V186.633H412.236V184.043Z",
    fill: "#EBF5FF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 188.39H409.646V190.98H412.236V188.39Z",
    fill: "#EBF5FF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 192.738H409.646V195.327H412.236V192.738Z",
    fill: "#EBF5FF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 197.084H409.646V199.674H412.236V197.084Z",
    fill: "#EBF5FF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 201.422H409.646V204.011H412.236V201.422Z",
    fill: "#EBF5FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 205.769H409.646V208.358H412.236V205.769Z",
    fill: "#EBF5FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 210.116H409.646V212.705H412.236V210.116Z",
    fill: "#EBF5FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 214.463H409.646V217.053H412.236V214.463Z",
    fill: "#EBF5FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 227.505H409.646V230.094H412.236V227.505Z",
    fill: "#EBF5FF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 231.852H409.646V234.442H412.236V231.852Z",
    fill: "#EBF5FF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M412.236 236.199H409.646V238.789H412.236V236.199Z",
    fill: "#EBF5FF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 164.065H363.283V166.654H365.872V164.065Z",
    fill: "#EBF5FF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 168.412H363.283V171.002H365.872V168.412Z",
    fill: "#EBF5FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 172.759H363.283V175.349H365.872V172.759Z",
    fill: "#EBF5FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 177.106H363.283V179.696H365.872V177.106Z",
    fill: "#EBF5FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 181.453H363.283V184.043H365.872V181.453Z",
    fill: "#EBF5FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 185.801H363.283V188.39H365.872V185.801Z",
    fill: "#EBF5FF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 190.137H363.283V192.727H365.872V190.137Z",
    fill: "#EBF5FF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 194.485H363.283V197.074H365.872V194.485Z",
    fill: "#EBF5FF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 207.526H363.283V210.116H365.872V207.526Z",
    fill: "#EBF5FF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M365.872 211.874H363.283V214.463H365.872V211.874Z",
    fill: "#EBF5FF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 164.065H359.165V166.654H361.755V164.065Z",
    fill: "#EBF5FF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 168.412H359.165V171.002H361.755V168.412Z",
    fill: "#EBF5FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 172.759H359.165V175.349H361.755V172.759Z",
    fill: "#EBF5FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 177.106H359.165V179.696H361.755V177.106Z",
    fill: "#EBF5FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 181.453H359.165V184.043H361.755V181.453Z",
    fill: "#EBF5FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 185.801H359.165V188.39H361.755V185.801Z",
    fill: "#EBF5FF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 190.137H359.165V192.727H361.755V190.137Z",
    fill: "#EBF5FF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 194.485H359.165V197.074H361.755V194.485Z",
    fill: "#EBF5FF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M361.755 211.874H359.165V214.463H361.755V211.874Z",
    fill: "#EBF5FF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 164.065H355.046V166.654H357.635V164.065Z",
    fill: "#EBF5FF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 168.412H355.046V171.002H357.635V168.412Z",
    fill: "#EBF5FF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 172.759H355.046V175.349H357.635V172.759Z",
    fill: "#EBF5FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 177.106H355.046V179.696H357.635V177.106Z",
    fill: "#EBF5FF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 181.453H355.046V184.043H357.635V181.453Z",
    fill: "#EBF5FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 185.801H355.046V188.39H357.635V185.801Z",
    fill: "#EBF5FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 190.137H355.046V192.727H357.635V190.137Z",
    fill: "#EBF5FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 194.485H355.046V197.074H357.635V194.485Z",
    fill: "#EBF5FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 164.065H350.928V166.654H353.517V164.065Z",
    fill: "#EBF5FF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 168.412H350.928V171.002H353.517V168.412Z",
    fill: "#EBF5FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 172.759H350.928V175.349H353.517V172.759Z",
    fill: "#EBF5FF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 177.106H350.928V179.696H353.517V177.106Z",
    fill: "#EBF5FF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 181.453H350.928V184.043H353.517V181.453Z",
    fill: "#EBF5FF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 185.801H350.928V188.39H353.517V185.801Z",
    fill: "#EBF5FF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 194.485H350.928V197.074H353.517V194.485Z",
    fill: "#EBF5FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 198.832H350.928V201.422H353.517V198.832Z",
    fill: "#EBF5FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 211.874H350.928V214.463H353.517V211.874Z",
    fill: "#EBF5FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 216.221H350.928V218.81H353.517V216.221Z",
    fill: "#EBF5FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 220.568H350.928V223.157H353.517V220.568Z",
    fill: "#EBF5FF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 224.915H350.928V227.505H353.517V224.915Z",
    fill: "#EBF5FF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 229.262H350.928V231.852H353.517V229.262Z",
    fill: "#EBF5FF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 233.599H350.928V236.189H353.517V233.599Z",
    fill: "#EBF5FF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M353.517 237.946H350.928V240.536H353.517V237.946Z",
    fill: "#EBF5FF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 164.065H346.81V166.654H349.399V164.065Z",
    fill: "#EBF5FF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 168.412H346.81V171.001H349.399V168.412Z",
    fill: "#EBF5FF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 172.759H346.81V175.349H349.399V172.759Z",
    fill: "#EBF5FF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 177.106H346.81V179.696H349.399V177.106Z",
    fill: "#EBF5FF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 181.454H346.81V184.043H349.399V181.454Z",
    fill: "#EBF5FF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 185.801H346.81V188.39H349.399V185.801Z",
    fill: "#EBF5FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 198.832H346.81V201.422H349.399V198.832Z",
    fill: "#EBF5FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 203.179H346.81V205.769H349.399V203.179Z",
    fill: "#EBF5FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 207.526H346.81V210.116H349.399V207.526Z",
    fill: "#EBF5FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 211.874H346.81V214.463H349.399V211.874Z",
    fill: "#EBF5FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 216.221H346.81V218.81H349.399V216.221Z",
    fill: "#EBF5FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 220.568H346.81V223.157H349.399V220.568Z",
    fill: "#EBF5FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 224.915H346.81V227.505H349.399V224.915Z",
    fill: "#EBF5FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 229.262H346.81V231.852H349.399V229.262Z",
    fill: "#EBF5FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 233.599H346.81V236.189H349.399V233.599Z",
    fill: "#EBF5FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 237.946H346.81V240.536H349.399V237.946Z",
    fill: "#EBF5FF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 242.293H346.81V244.883H349.399V242.293Z",
    fill: "#EBF5FF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M349.399 250.988H346.81V253.577H349.399V250.988Z",
    fill: "#EBF5FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 164.065H342.691V166.654H345.28V164.065Z",
    fill: "#EBF5FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 168.412H342.691V171.001H345.28V168.412Z",
    fill: "#EBF5FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 172.759H342.691V175.349H345.28V172.759Z",
    fill: "#EBF5FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 177.106H342.691V179.696H345.28V177.106Z",
    fill: "#EBF5FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 181.454H342.691V184.043H345.28V181.454Z",
    fill: "#EBF5FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 185.801H342.691V188.39H345.28V185.801Z",
    fill: "#EBF5FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 198.832H342.691V201.422H345.28V198.832Z",
    fill: "#EBF5FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 203.179H342.691V205.769H345.28V203.179Z",
    fill: "#EBF5FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 207.526H342.691V210.116H345.28V207.526Z",
    fill: "#EBF5FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 211.874H342.691V214.463H345.28V211.874Z",
    fill: "#EBF5FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 224.915H342.691V227.505H345.28V224.915Z",
    fill: "#EBF5FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 229.262H342.691V231.852H345.28V229.262Z",
    fill: "#EBF5FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 233.599H342.691V236.189H345.28V233.599Z",
    fill: "#EBF5FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 237.946H342.691V240.536H345.28V237.946Z",
    fill: "#EBF5FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 242.293H342.691V244.883H345.28V242.293Z",
    fill: "#EBF5FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 250.988H342.691V253.577H345.28V250.988Z",
    fill: "#EBF5FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M345.28 255.335H342.691V257.925H345.28V255.335Z",
    fill: "#EBF5FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 204.479H305.334V207.069H307.924V204.479Z",
    fill: "#EBF5FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 208.826H305.334V211.416H307.924V208.826Z",
    fill: "#EBF5FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 213.174H305.334V215.763H307.924V213.174Z",
    fill: "#EBF5FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 217.51H305.334V220.1H307.924V217.51Z",
    fill: "#EBF5FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 221.857H305.334V224.447H307.924V221.857Z",
    fill: "#EBF5FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 226.205H305.334V228.794H307.924V226.205Z",
    fill: "#EBF5FF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 230.552H305.334V233.142H307.924V230.552Z",
    fill: "#EBF5FF"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 243.594H305.334V246.183H307.924V243.594Z",
    fill: "#EBF5FF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 247.941H305.334V250.53H307.924V247.941Z",
    fill: "#EBF5FF"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M307.924 252.288H305.334V254.877H307.924V252.288Z",
    fill: "#EBF5FF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 204.479H301.216V207.069H303.806V204.479Z",
    fill: "#EBF5FF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 208.826H301.216V211.416H303.806V208.826Z",
    fill: "#EBF5FF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 213.174H301.216V215.763H303.806V213.174Z",
    fill: "#EBF5FF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 217.51H301.216V220.1H303.806V217.51Z",
    fill: "#EBF5FF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 221.858H301.216V224.447H303.806V221.858Z",
    fill: "#EBF5FF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 226.205H301.216V228.794H303.806V226.205Z",
    fill: "#EBF5FF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M303.806 230.552H301.216V233.141H303.806V230.552Z",
    fill: "#EBF5FF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 204.479H297.097V207.069H299.687V204.479Z",
    fill: "#EBF5FF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 208.826H297.097V211.416H299.687V208.826Z",
    fill: "#EBF5FF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 213.174H297.097V215.763H299.687V213.174Z",
    fill: "#EBF5FF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 217.51H297.097V220.1H299.687V217.51Z",
    fill: "#EBF5FF"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 221.858H297.097V224.447H299.687V221.858Z",
    fill: "#EBF5FF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 226.205H297.097V228.794H299.687V226.205Z",
    fill: "#EBF5FF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M299.687 230.552H297.097V233.141H299.687V230.552Z",
    fill: "#EBF5FF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 204.479H292.979V207.069H295.569V204.479Z",
    fill: "#EBF5FF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 208.826H292.979V211.416H295.569V208.826Z",
    fill: "#EBF5FF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 213.174H292.979V215.763H295.569V213.174Z",
    fill: "#EBF5FF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 217.51H292.979V220.1H295.569V217.51Z",
    fill: "#EBF5FF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 221.858H292.979V224.447H295.569V221.858Z",
    fill: "#EBF5FF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 226.205H292.979V228.794H295.569V226.205Z",
    fill: "#EBF5FF"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 230.552H292.979V233.141H295.569V230.552Z",
    fill: "#EBF5FF"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 234.899H292.979V237.489H295.569V234.899Z",
    fill: "#EBF5FF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 239.246H292.979V241.836H295.569V239.246Z",
    fill: "#EBF5FF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 243.594H292.979V246.183H295.569V243.594Z",
    fill: "#EBF5FF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M295.569 247.941H292.979V250.53H295.569V247.941Z",
    fill: "#EBF5FF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 204.479H288.86V207.069H291.45V204.479Z",
    fill: "#EBF5FF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 208.826H288.86V211.416H291.45V208.826Z",
    fill: "#EBF5FF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 213.174H288.86V215.763H291.45V213.174Z",
    fill: "#EBF5FF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 217.51H288.86V220.1H291.45V217.51Z",
    fill: "#EBF5FF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 221.858H288.86V224.447H291.45V221.858Z",
    fill: "#EBF5FF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 226.205H288.86V228.794H291.45V226.205Z",
    fill: "#EBF5FF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 230.552H288.86V233.141H291.45V230.552Z",
    fill: "#EBF5FF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 234.899H288.86V237.489H291.45V234.899Z",
    fill: "#EBF5FF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 239.246H288.86V241.836H291.45V239.246Z",
    fill: "#EBF5FF"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 243.594H288.86V246.183H291.45V243.594Z",
    fill: "#EBF5FF"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 247.941H288.86V250.53H291.45V247.941Z",
    fill: "#EBF5FF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 252.288H288.86V254.877H291.45V252.288Z",
    fill: "#EBF5FF"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 265.319H288.86V267.909H291.45V265.319Z",
    fill: "#EBF5FF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M291.45 269.666H288.86V272.256H291.45V269.666Z",
    fill: "#EBF5FF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 204.479H284.742V207.069H287.332V204.479Z",
    fill: "#EBF5FF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 208.826H284.742V211.416H287.332V208.826Z",
    fill: "#EBF5FF"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 213.174H284.742V215.763H287.332V213.174Z",
    fill: "#EBF5FF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 226.205H284.742V228.794H287.332V226.205Z",
    fill: "#EBF5FF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 230.552H284.742V233.141H287.332V230.552Z",
    fill: "#EBF5FF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 234.899H284.742V237.489H287.332V234.899Z",
    fill: "#EBF5FF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 239.246H284.742V241.836H287.332V239.246Z",
    fill: "#EBF5FF"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 243.594H284.742V246.183H287.332V243.594Z",
    fill: "#EBF5FF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 247.941H284.742V250.53H287.332V247.941Z",
    fill: "#EBF5FF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 252.288H284.742V254.877H287.332V252.288Z",
    fill: "#EBF5FF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 265.319H284.742V267.909H287.332V265.319Z",
    fill: "#EBF5FF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 269.666H284.742V272.256H287.332V269.666Z",
    fill: "#EBF5FF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M287.332 274.013H284.742V276.603H287.332V274.013Z",
    fill: "#EBF5FF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 178.396H241.592V180.986H244.182V178.396Z",
    fill: "#EBF5FF"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 182.743H241.592V185.333H244.182V182.743Z",
    fill: "#EBF5FF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 187.09H241.592V189.68H244.182V187.09Z",
    fill: "#EBF5FF"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 191.438H241.592V194.027H244.182V191.438Z",
    fill: "#EBF5FF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 195.785H241.592V198.374H244.182V195.785Z",
    fill: "#EBF5FF"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 200.132H241.592V202.721H244.182V200.132Z",
    fill: "#EBF5FF"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 204.479H241.592V207.069H244.182V204.479Z",
    fill: "#EBF5FF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 208.826H241.592V211.416H244.182V208.826Z",
    fill: "#EBF5FF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 213.174H241.592V215.763H244.182V213.174Z",
    fill: "#EBF5FF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 217.51H241.592V220.1H244.182V217.51Z",
    fill: "#EBF5FF"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 221.858H241.592V224.447H244.182V221.858Z",
    fill: "#EBF5FF"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 226.205H241.592V228.794H244.182V226.205Z",
    fill: "#EBF5FF"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 230.552H241.592V233.141H244.182V230.552Z",
    fill: "#EBF5FF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 234.899H241.592V237.489H244.182V234.899Z",
    fill: "#EBF5FF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 239.246H241.592V241.836H244.182V239.246Z",
    fill: "#EBF5FF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 243.594H241.592V246.183H244.182V243.594Z",
    fill: "#EBF5FF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 247.941H241.592V250.53H244.182V247.941Z",
    fill: "#EBF5FF"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 252.288H241.592V254.877H244.182V252.288Z",
    fill: "#EBF5FF"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 256.635H241.592V259.225H244.182V256.635Z",
    fill: "#EBF5FF"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 260.972H241.592V263.562H244.182V260.972Z",
    fill: "#EBF5FF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 265.319H241.592V267.909H244.182V265.319Z",
    fill: "#EBF5FF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 269.666H241.592V272.256H244.182V269.666Z",
    fill: "#EBF5FF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M244.182 274.013H241.592V276.603H244.182V274.013Z",
    fill: "#EBF5FF"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 178.396H237.475V180.986H240.064V178.396Z",
    fill: "#EBF5FF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 182.743H237.475V185.333H240.064V182.743Z",
    fill: "#EBF5FF"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 187.09H237.475V189.68H240.064V187.09Z",
    fill: "#EBF5FF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 191.438H237.475V194.027H240.064V191.438Z",
    fill: "#EBF5FF"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 195.785H237.475V198.374H240.064V195.785Z",
    fill: "#EBF5FF"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 200.132H237.475V202.721H240.064V200.132Z",
    fill: "#EBF5FF"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 204.479H237.475V207.069H240.064V204.479Z",
    fill: "#EBF5FF"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 208.826H237.475V211.416H240.064V208.826Z",
    fill: "#EBF5FF"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 213.174H237.475V215.763H240.064V213.174Z",
    fill: "#EBF5FF"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 217.51H237.475V220.1H240.064V217.51Z",
    fill: "#EBF5FF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 221.858H237.475V224.447H240.064V221.858Z",
    fill: "#EBF5FF"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 226.205H237.475V228.794H240.064V226.205Z",
    fill: "#EBF5FF"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 230.552H237.475V233.141H240.064V230.552Z",
    fill: "#EBF5FF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 234.899H237.475V237.489H240.064V234.899Z",
    fill: "#EBF5FF"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 239.246H237.475V241.836H240.064V239.246Z",
    fill: "#EBF5FF"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 243.594H237.475V246.183H240.064V243.594Z",
    fill: "#EBF5FF"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 247.941H237.475V250.53H240.064V247.941Z",
    fill: "#EBF5FF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 252.288H237.475V254.877H240.064V252.288Z",
    fill: "#EBF5FF"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M240.064 256.635H237.475V259.225H240.064V256.635Z",
    fill: "#EBF5FF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 178.396H233.355V180.986H235.945V178.396Z",
    fill: "#EBF5FF"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 182.743H233.355V185.333H235.945V182.743Z",
    fill: "#EBF5FF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 187.09H233.355V189.68H235.945V187.09Z",
    fill: "#EBF5FF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 191.438H233.355V194.027H235.945V191.438Z",
    fill: "#EBF5FF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 195.785H233.355V198.374H235.945V195.785Z",
    fill: "#EBF5FF"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 200.132H233.355V202.721H235.945V200.132Z",
    fill: "#EBF5FF"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 204.479H233.355V207.069H235.945V204.479Z",
    fill: "#EBF5FF"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 208.826H233.355V211.416H235.945V208.826Z",
    fill: "#EBF5FF"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 213.174H233.355V215.763H235.945V213.174Z",
    fill: "#EBF5FF"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 217.51H233.355V220.1H235.945V217.51Z",
    fill: "#EBF5FF"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 221.858H233.355V224.447H235.945V221.858Z",
    fill: "#EBF5FF"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 226.205H233.355V228.794H235.945V226.205Z",
    fill: "#EBF5FF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 230.552H233.355V233.141H235.945V230.552Z",
    fill: "#EBF5FF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 234.899H233.355V237.489H235.945V234.899Z",
    fill: "#EBF5FF"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 239.246H233.355V241.836H235.945V239.246Z",
    fill: "#EBF5FF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 243.594H233.355V246.183H235.945V243.594Z",
    fill: "#EBF5FF"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 247.941H233.355V250.53H235.945V247.941Z",
    fill: "#EBF5FF"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 252.288H233.355V254.877H235.945V252.288Z",
    fill: "#EBF5FF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M235.945 256.635H233.355V259.225H235.945V256.635Z",
    fill: "#EBF5FF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 178.396H229.237V180.986H231.827V178.396Z",
    fill: "#EBF5FF"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 182.743H229.237V185.333H231.827V182.743Z",
    fill: "#EBF5FF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 187.09H229.237V189.68H231.827V187.09Z",
    fill: "#EBF5FF"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 191.438H229.237V194.027H231.827V191.438Z",
    fill: "#EBF5FF"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 195.785H229.237V198.374H231.827V195.785Z",
    fill: "#EBF5FF"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 200.132H229.237V202.721H231.827V200.132Z",
    fill: "#EBF5FF"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 204.479H229.237V207.069H231.827V204.479Z",
    fill: "#EBF5FF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 208.826H229.237V211.416H231.827V208.826Z",
    fill: "#EBF5FF"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 213.174H229.237V215.763H231.827V213.174Z",
    fill: "#EBF5FF"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 217.51H229.237V220.1H231.827V217.51Z",
    fill: "#EBF5FF"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 221.858H229.237V224.447H231.827V221.858Z",
    fill: "#EBF5FF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 226.205H229.237V228.794H231.827V226.205Z",
    fill: "#EBF5FF"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 230.552H229.237V233.141H231.827V230.552Z",
    fill: "#EBF5FF"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 234.899H229.237V237.489H231.827V234.899Z",
    fill: "#EBF5FF"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M231.827 239.246H229.237V241.836H231.827V239.246Z",
    fill: "#EBF5FF"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 178.396H225.119V180.986H227.709V178.396Z",
    fill: "#EBF5FF"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 182.743H225.119V185.333H227.709V182.743Z",
    fill: "#EBF5FF"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 187.09H225.119V189.68H227.709V187.09Z",
    fill: "#EBF5FF"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 191.438H225.119V194.027H227.709V191.438Z",
    fill: "#EBF5FF"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 195.785H225.119V198.374H227.709V195.785Z",
    fill: "#EBF5FF"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 200.132H225.119V202.721H227.709V200.132Z",
    fill: "#EBF5FF"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 204.479H225.119V207.069H227.709V204.479Z",
    fill: "#EBF5FF"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 208.826H225.119V211.416H227.709V208.826Z",
    fill: "#EBF5FF"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 213.174H225.119V215.763H227.709V213.174Z",
    fill: "#EBF5FF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 217.51H225.119V220.1H227.709V217.51Z",
    fill: "#EBF5FF"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 221.857H225.119V224.447H227.709V221.857Z",
    fill: "#EBF5FF"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 226.205H225.119V228.794H227.709V226.205Z",
    fill: "#EBF5FF"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M227.709 230.552H225.119V233.142H227.709V230.552Z",
    fill: "#EBF5FF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 178.396H221V180.986H223.59V178.396Z",
    fill: "#EBF5FF"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 182.743H221V185.333H223.59V182.743Z",
    fill: "#EBF5FF"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 187.09H221V189.68H223.59V187.09Z",
    fill: "#EBF5FF"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 191.438H221V194.027H223.59V191.438Z",
    fill: "#EBF5FF"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 195.785H221V198.374H223.59V195.785Z",
    fill: "#EBF5FF"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 200.132H221V202.721H223.59V200.132Z",
    fill: "#EBF5FF"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 204.479H221V207.069H223.59V204.479Z",
    fill: "#EBF5FF"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 208.826H221V211.416H223.59V208.826Z",
    fill: "#EBF5FF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 213.174H221V215.763H223.59V213.174Z",
    fill: "#EBF5FF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 217.51H221V220.1H223.59V217.51Z",
    fill: "#EBF5FF"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 221.857H221V224.447H223.59V221.857Z",
    fill: "#EBF5FF"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M223.59 226.205H221V228.794H223.59V226.205Z",
    fill: "#EBF5FF"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 177.106H461.334V179.696H463.924V177.106Z",
    fill: "#EBF5FF"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 181.453H461.334V184.043H463.924V181.453Z",
    fill: "#EBF5FF"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 185.801H461.334V188.39H463.924V185.801Z",
    fill: "#EBF5FF"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 190.137H461.334V192.727H463.924V190.137Z",
    fill: "#EBF5FF"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 194.485H461.334V197.074H463.924V194.485Z",
    fill: "#EBF5FF"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 198.832H461.334V201.422H463.924V198.832Z",
    fill: "#EBF5FF"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 203.179H461.334V205.769H463.924V203.179Z",
    fill: "#EBF5FF"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 207.526H461.334V210.116H463.924V207.526Z",
    fill: "#EBF5FF"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 211.874H461.334V214.463H463.924V211.874Z",
    fill: "#EBF5FF"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 216.221H461.334V218.81H463.924V216.221Z",
    fill: "#EBF5FF"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 220.568H461.334V223.157H463.924V220.568Z",
    fill: "#EBF5FF"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 224.915H461.334V227.505H463.924V224.915Z",
    fill: "#EBF5FF"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 229.262H461.334V231.852H463.924V229.262Z",
    fill: "#EBF5FF"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 233.599H461.334V236.189H463.924V233.599Z",
    fill: "#EBF5FF"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 237.946H461.334V240.536H463.924V237.946Z",
    fill: "#EBF5FF"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 242.293H461.334V244.883H463.924V242.293Z",
    fill: "#EBF5FF"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 246.641H461.334V249.23H463.924V246.641Z",
    fill: "#EBF5FF"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 255.335H461.334V257.925H463.924V255.335Z",
    fill: "#EBF5FF"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 259.682H461.334V262.272H463.924V259.682Z",
    fill: "#EBF5FF"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 264.03H461.334V266.619H463.924V264.03Z",
    fill: "#EBF5FF"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 268.377H461.334V270.966H463.924V268.377Z",
    fill: "#EBF5FF"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M463.924 272.714H461.334V275.303H463.924V272.714Z",
    fill: "#EBF5FF"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 177.106H457.216V179.696H459.805V177.106Z",
    fill: "#EBF5FF"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 181.454H457.216V184.043H459.805V181.454Z",
    fill: "#EBF5FF"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 185.801H457.216V188.39H459.805V185.801Z",
    fill: "#EBF5FF"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 190.137H457.216V192.727H459.805V190.137Z",
    fill: "#EBF5FF"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 194.485H457.216V197.074H459.805V194.485Z",
    fill: "#EBF5FF"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 198.832H457.216V201.422H459.805V198.832Z",
    fill: "#EBF5FF"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 203.179H457.216V205.769H459.805V203.179Z",
    fill: "#EBF5FF"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 207.526H457.216V210.116H459.805V207.526Z",
    fill: "#EBF5FF"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 211.874H457.216V214.463H459.805V211.874Z",
    fill: "#EBF5FF"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 216.221H457.216V218.81H459.805V216.221Z",
    fill: "#EBF5FF"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 220.568H457.216V223.157H459.805V220.568Z",
    fill: "#EBF5FF"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 224.915H457.216V227.505H459.805V224.915Z",
    fill: "#EBF5FF"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 229.262H457.216V231.852H459.805V229.262Z",
    fill: "#EBF5FF"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 233.599H457.216V236.189H459.805V233.599Z",
    fill: "#EBF5FF"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 237.946H457.216V240.536H459.805V237.946Z",
    fill: "#EBF5FF"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 242.293H457.216V244.883H459.805V242.293Z",
    fill: "#EBF5FF"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 268.377H457.216V270.966H459.805V268.377Z",
    fill: "#EBF5FF"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M459.805 272.713H457.216V275.303H459.805V272.713Z",
    fill: "#EBF5FF"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 177.106H453.108V179.696H455.698V177.106Z",
    fill: "#EBF5FF"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 181.454H453.108V184.043H455.698V181.454Z",
    fill: "#EBF5FF"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 185.801H453.108V188.39H455.698V185.801Z",
    fill: "#EBF5FF"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 190.137H453.108V192.727H455.698V190.137Z",
    fill: "#EBF5FF"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 194.485H453.108V197.074H455.698V194.485Z",
    fill: "#EBF5FF"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 198.832H453.108V201.422H455.698V198.832Z",
    fill: "#EBF5FF"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 203.179H453.108V205.769H455.698V203.179Z",
    fill: "#EBF5FF"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 207.526H453.108V210.116H455.698V207.526Z",
    fill: "#EBF5FF"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 211.874H453.108V214.463H455.698V211.874Z",
    fill: "#EBF5FF"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 216.221H453.108V218.81H455.698V216.221Z",
    fill: "#EBF5FF"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 220.568H453.108V223.157H455.698V220.568Z",
    fill: "#EBF5FF"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 224.915H453.108V227.505H455.698V224.915Z",
    fill: "#EBF5FF"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 229.262H453.108V231.852H455.698V229.262Z",
    fill: "#EBF5FF"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 233.599H453.108V236.189H455.698V233.599Z",
    fill: "#EBF5FF"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 237.946H453.108V240.536H455.698V237.946Z",
    fill: "#EBF5FF"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 242.293H453.108V244.883H455.698V242.293Z",
    fill: "#EBF5FF"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 250.988H453.108V253.577H455.698V250.988Z",
    fill: "#EBF5FF"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 255.335H453.108V257.925H455.698V255.335Z",
    fill: "#EBF5FF"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 259.682H453.108V262.272H455.698V259.682Z",
    fill: "#EBF5FF"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 264.03H453.108V266.619H455.698V264.03Z",
    fill: "#EBF5FF"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M455.698 272.713H453.108V275.303H455.698V272.713Z",
    fill: "#EBF5FF"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 207.526H381.275V210.116H383.865V207.526Z",
    fill: "#EBF5FF"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 211.874H381.275V214.463H383.865V211.874Z",
    fill: "#EBF5FF"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 216.221H381.275V218.81H383.865V216.221Z",
    fill: "#EBF5FF"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 220.568H381.275V223.157H383.865V220.568Z",
    fill: "#EBF5FF"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 224.915H381.275V227.505H383.865V224.915Z",
    fill: "#EBF5FF"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 229.262H381.275V231.852H383.865V229.262Z",
    fill: "#EBF5FF"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 233.599H381.275V236.189H383.865V233.599Z",
    fill: "#EBF5FF"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 237.946H381.275V240.536H383.865V237.946Z",
    fill: "#EBF5FF"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 242.293H381.275V244.883H383.865V242.293Z",
    fill: "#EBF5FF"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 246.641H381.275V249.23H383.865V246.641Z",
    fill: "#EBF5FF"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 250.988H381.275V253.577H383.865V250.988Z",
    fill: "#EBF5FF"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 255.335H381.275V257.925H383.865V255.335Z",
    fill: "#EBF5FF"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 259.682H381.275V262.272H383.865V259.682Z",
    fill: "#EBF5FF"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 268.377H381.275V270.966H383.865V268.377Z",
    fill: "#EBF5FF"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 272.714H381.275V275.303H383.865V272.714Z",
    fill: "#EBF5FF"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 277.061H381.275V279.65H383.865V277.061Z",
    fill: "#EBF5FF"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 281.408H381.275V283.998H383.865V281.408Z",
    fill: "#EBF5FF"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 290.102H381.275V292.692H383.865V290.102Z",
    fill: "#EBF5FF"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 294.449H381.275V297.039H383.865V294.449Z",
    fill: "#EBF5FF"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M383.865 298.797H381.275V301.386H383.865V298.797Z",
    fill: "#EBF5FF"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 207.526H377.156V210.116H379.746V207.526Z",
    fill: "#EBF5FF"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 211.874H377.156V214.463H379.746V211.874Z",
    fill: "#EBF5FF"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 216.221H377.156V218.81H379.746V216.221Z",
    fill: "#EBF5FF"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 220.568H377.156V223.157H379.746V220.568Z",
    fill: "#EBF5FF"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 224.915H377.156V227.505H379.746V224.915Z",
    fill: "#EBF5FF"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 229.262H377.156V231.852H379.746V229.262Z",
    fill: "#EBF5FF"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 233.599H377.156V236.189H379.746V233.599Z",
    fill: "#EBF5FF"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 237.946H377.156V240.536H379.746V237.946Z",
    fill: "#EBF5FF"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 242.293H377.156V244.883H379.746V242.293Z",
    fill: "#EBF5FF"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 246.641H377.156V249.23H379.746V246.641Z",
    fill: "#EBF5FF"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 250.988H377.156V253.577H379.746V250.988Z",
    fill: "#EBF5FF"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 255.335H377.156V257.925H379.746V255.335Z",
    fill: "#EBF5FF"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 259.682H377.156V262.272H379.746V259.682Z",
    fill: "#EBF5FF"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 272.714H377.156V275.303H379.746V272.714Z",
    fill: "#EBF5FF"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 277.061H377.156V279.65H379.746V277.061Z",
    fill: "#EBF5FF"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 285.755H377.156V288.345H379.746V285.755Z",
    fill: "#EBF5FF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 290.102H377.156V292.692H379.746V290.102Z",
    fill: "#EBF5FF"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 294.449H377.156V297.039H379.746V294.449Z",
    fill: "#EBF5FF"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M379.746 298.797H377.156V301.386H379.746V298.797Z",
    fill: "#EBF5FF"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 207.526H373.038V210.116H375.628V207.526Z",
    fill: "#EBF5FF"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 211.874H373.038V214.463H375.628V211.874Z",
    fill: "#EBF5FF"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 216.221H373.038V218.81H375.628V216.221Z",
    fill: "#EBF5FF"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 220.568H373.038V223.157H375.628V220.568Z",
    fill: "#EBF5FF"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 224.915H373.038V227.505H375.628V224.915Z",
    fill: "#EBF5FF"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 229.262H373.038V231.852H375.628V229.262Z",
    fill: "#EBF5FF"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 233.599H373.038V236.189H375.628V233.599Z",
    fill: "#EBF5FF"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 237.946H373.038V240.536H375.628V237.946Z",
    fill: "#EBF5FF"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 242.293H373.038V244.883H375.628V242.293Z",
    fill: "#EBF5FF"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 246.641H373.038V249.23H375.628V246.641Z",
    fill: "#EBF5FF"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 250.988H373.038V253.577H375.628V250.988Z",
    fill: "#EBF5FF"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 255.335H373.038V257.925H375.628V255.335Z",
    fill: "#EBF5FF"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 259.682H373.038V262.272H375.628V259.682Z",
    fill: "#EBF5FF"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 264.03H373.038V266.619H375.628V264.03Z",
    fill: "#EBF5FF"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 272.714H373.038V275.303H375.628V272.714Z",
    fill: "#EBF5FF"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 281.408H373.038V283.998H375.628V281.408Z",
    fill: "#EBF5FF"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 285.755H373.038V288.345H375.628V285.755Z",
    fill: "#EBF5FF"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 290.102H373.038V292.692H375.628V290.102Z",
    fill: "#EBF5FF"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 294.449H373.038V297.039H375.628V294.449Z",
    fill: "#EBF5FF"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M375.628 298.797H373.038V301.386H375.628V298.797Z",
    fill: "#EBF5FF"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 232.309H398.05V234.899H400.639V232.309Z",
    fill: "#EBF5FF"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 236.657H398.05V239.246H400.639V236.657Z",
    fill: "#EBF5FF"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 241.004H398.05V243.594H400.639V241.004Z",
    fill: "#EBF5FF"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 245.341H398.05V247.93H400.639V245.341Z",
    fill: "#EBF5FF"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 249.688H398.05V252.278H400.639V249.688Z",
    fill: "#EBF5FF"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 254.035H398.05V256.625H400.639V254.035Z",
    fill: "#EBF5FF"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 267.077H398.05V269.666H400.639V267.077Z",
    fill: "#EBF5FF"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 271.424H398.05V274.013H400.639V271.424Z",
    fill: "#EBF5FF"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 275.771H398.05V278.361H400.639V275.771Z",
    fill: "#EBF5FF"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 280.118H398.05V282.708H400.639V280.118Z",
    fill: "#EBF5FF"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 284.466H398.05V287.055H400.639V284.466Z",
    fill: "#EBF5FF"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 288.802H398.05V291.392H400.639V288.802Z",
    fill: "#EBF5FF"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M400.639 293.149H398.05V295.739H400.639V293.149Z",
    fill: "#EBF5FF"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 232.309H393.933V234.899H396.522V232.309Z",
    fill: "#EBF5FF"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 236.657H393.933V239.246H396.522V236.657Z",
    fill: "#EBF5FF"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 241.004H393.933V243.594H396.522V241.004Z",
    fill: "#EBF5FF"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 245.341H393.933V247.93H396.522V245.341Z",
    fill: "#EBF5FF"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 249.688H393.933V252.278H396.522V249.688Z",
    fill: "#EBF5FF"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 254.035H393.933V256.625H396.522V254.035Z",
    fill: "#EBF5FF"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 267.077H393.933V269.666H396.522V267.077Z",
    fill: "#EBF5FF"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 271.424H393.933V274.013H396.522V271.424Z",
    fill: "#EBF5FF"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 275.771H393.933V278.361H396.522V275.771Z",
    fill: "#EBF5FF"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 280.118H393.933V282.708H396.522V280.118Z",
    fill: "#EBF5FF"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 284.466H393.933V287.055H396.522V284.466Z",
    fill: "#EBF5FF"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 288.802H393.933V291.392H396.522V288.802Z",
    fill: "#EBF5FF"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M396.522 297.497H393.933V300.086H396.522V297.497Z",
    fill: "#EBF5FF"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 213.174H257.141V215.763H259.731V213.174Z",
    fill: "#EBF5FF"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 217.51H257.141V220.1H259.731V217.51Z",
    fill: "#EBF5FF"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 221.857H257.141V224.447H259.731V221.857Z",
    fill: "#EBF5FF"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 226.205H257.141V228.794H259.731V226.205Z",
    fill: "#EBF5FF"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 230.552H257.141V233.142H259.731V230.552Z",
    fill: "#EBF5FF"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 234.899H257.141V237.489H259.731V234.899Z",
    fill: "#EBF5FF"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 239.246H257.141V241.836H259.731V239.246Z",
    fill: "#EBF5FF"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 243.594H257.141V246.183H259.731V243.594Z",
    fill: "#EBF5FF"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 247.941H257.141V250.53H259.731V247.941Z",
    fill: "#EBF5FF"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 252.288H257.141V254.877H259.731V252.288Z",
    fill: "#EBF5FF"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 256.635H257.141V259.225H259.731V256.635Z",
    fill: "#EBF5FF"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 265.319H257.141V267.909H259.731V265.319Z",
    fill: "#EBF5FF"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 269.666H257.141V272.256H259.731V269.666Z",
    fill: "#EBF5FF"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 274.014H257.141V276.603H259.731V274.014Z",
    fill: "#EBF5FF"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 278.361H257.141V280.95H259.731V278.361Z",
    fill: "#EBF5FF"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 282.708H257.141V285.298H259.731V282.708Z",
    fill: "#EBF5FF"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 287.055H257.141V289.645H259.731V287.055Z",
    fill: "#EBF5FF"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 291.402H257.141V293.992H259.731V291.402Z",
    fill: "#EBF5FF"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M259.731 295.75H257.141V298.339H259.731V295.75Z",
    fill: "#EBF5FF"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 213.174H253.033V215.763H255.623V213.174Z",
    fill: "#EBF5FF"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 217.51H253.033V220.1H255.623V217.51Z",
    fill: "#EBF5FF"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 221.858H253.033V224.447H255.623V221.858Z",
    fill: "#EBF5FF"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 226.205H253.033V228.794H255.623V226.205Z",
    fill: "#EBF5FF"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 230.552H253.033V233.141H255.623V230.552Z",
    fill: "#EBF5FF"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 234.899H253.033V237.489H255.623V234.899Z",
    fill: "#EBF5FF"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 239.246H253.033V241.836H255.623V239.246Z",
    fill: "#EBF5FF"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 243.594H253.033V246.183H255.623V243.594Z",
    fill: "#EBF5FF"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 247.941H253.033V250.53H255.623V247.941Z",
    fill: "#EBF5FF"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 252.288H253.033V254.877H255.623V252.288Z",
    fill: "#EBF5FF"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 256.635H253.033V259.225H255.623V256.635Z",
    fill: "#EBF5FF"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 260.972H253.033V263.562H255.623V260.972Z",
    fill: "#EBF5FF"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 265.319H253.033V267.909H255.623V265.319Z",
    fill: "#EBF5FF"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 269.666H253.033V272.256H255.623V269.666Z",
    fill: "#EBF5FF"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 274.013H253.033V276.603H255.623V274.013Z",
    fill: "#EBF5FF"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 278.361H253.033V280.95H255.623V278.361Z",
    fill: "#EBF5FF"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 282.708H253.033V285.298H255.623V282.708Z",
    fill: "#EBF5FF"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 287.055H253.033V289.645H255.623V287.055Z",
    fill: "#EBF5FF"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 291.402H253.033V293.992H255.623V291.402Z",
    fill: "#EBF5FF"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M255.623 295.75H253.033V298.339H255.623V295.75Z",
    fill: "#EBF5FF"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 230.094H277.431V232.684H280.021V230.094Z",
    fill: "#EBF5FF"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 234.441H277.431V237.031H280.021V234.441Z",
    fill: "#EBF5FF"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 238.789H277.431V241.378H280.021V238.789Z",
    fill: "#EBF5FF"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 243.136H277.431V245.726H280.021V243.136Z",
    fill: "#EBF5FF"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 247.483H277.431V250.073H280.021V247.483Z",
    fill: "#EBF5FF"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 251.83H277.431V254.42H280.021V251.83Z",
    fill: "#EBF5FF"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 256.177H277.431V258.767H280.021V256.177Z",
    fill: "#EBF5FF"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 260.514H277.431V263.104H280.021V260.514Z",
    fill: "#EBF5FF"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 264.862H277.431V267.451H280.021V264.862Z",
    fill: "#EBF5FF"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M280.021 269.209H277.431V271.798H280.021V269.209Z",
    fill: "#EBF5FF"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 230.094H273.313V232.684H275.903V230.094Z",
    fill: "#EBF5FF"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 234.441H273.313V237.031H275.903V234.441Z",
    fill: "#EBF5FF"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 238.789H273.313V241.378H275.903V238.789Z",
    fill: "#EBF5FF"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 243.136H273.313V245.726H275.903V243.136Z",
    fill: "#EBF5FF"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 247.483H273.313V250.073H275.903V247.483Z",
    fill: "#EBF5FF"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 251.83H273.313V254.42H275.903V251.83Z",
    fill: "#EBF5FF"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 256.177H273.313V258.767H275.903V256.177Z",
    fill: "#EBF5FF"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 260.514H273.313V263.104H275.903V260.514Z",
    fill: "#EBF5FF"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M275.903 264.862H273.313V267.451H275.903V264.862Z",
    fill: "#EBF5FF"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M300.394 65.1606H296.047V307.564H300.394V65.1606Z",
    fill: "#D2DEED"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M382.253 65.1606H377.906V307.564H382.253V65.1606Z",
    fill: "#D2DEED"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M464.101 65.1606H459.753V307.564H464.101V65.1606Z",
    fill: "#D2DEED"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M154.721 283.935H181.532C182.749 283.935 183.915 284.418 184.775 285.278C185.636 286.138 186.119 287.305 186.119 288.521V340.345H150.145V288.563C150.14 287.958 150.254 287.358 150.481 286.798C150.709 286.237 151.045 285.727 151.47 285.297C151.895 284.867 152.402 284.525 152.96 284.291C153.518 284.057 154.116 283.936 154.721 283.935Z",
    fill: "#EBF5FF"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M186.119 291.61H150.145V295.656H186.119V291.61Z",
    fill: "#CDE2FF"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M170.603 333.553H179.567C180.221 333.553 180.848 333.813 181.31 334.275C181.773 334.738 182.032 335.365 182.032 336.018V340.386H168.127V336.018C168.127 335.694 168.192 335.372 168.316 335.073C168.441 334.773 168.623 334.501 168.853 334.272C169.083 334.043 169.356 333.861 169.656 333.738C169.956 333.615 170.278 333.552 170.603 333.553Z",
    fill: "#D2DEED"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M182.074 340.386H172.11C171.686 340.386 171.278 340.217 170.978 339.917C170.678 339.617 170.509 339.209 170.509 338.785C170.512 338.362 170.681 337.957 170.982 337.659C171.282 337.361 171.687 337.193 172.11 337.193H182.074C182.497 337.193 182.902 337.361 183.202 337.659C183.502 337.957 183.672 338.362 183.675 338.785C183.675 339.209 183.506 339.617 183.206 339.917C182.906 340.217 182.498 340.386 182.074 340.386Z",
    fill: "#CDE2FF"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M341.811 53.7878C354.976 50.6806 363.13 37.4895 360.022 24.3247C356.915 11.1598 343.724 3.00651 330.559 6.11369C317.394 9.22088 309.241 22.412 312.348 35.5768C315.455 48.7416 328.646 56.895 341.811 53.7878Z",
    fill: "url(#paint0_linear_405_3876)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M339.517 50.4844C350.873 48.6411 358.584 37.9408 356.741 26.5847C354.898 15.2286 344.197 7.51695 332.841 9.3603C321.485 11.2037 313.774 21.9039 315.617 33.2601C317.46 44.6162 328.161 52.3278 339.517 50.4844Z",
    fill: "#EBF5FF"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M337.168 15.6462V30.2062L346.809 24.7462",
    fill: "#EBF5FF"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M337.169 31.2152C336.982 31.2151 336.799 31.1648 336.638 31.0696C336.483 30.9775 336.355 30.8467 336.265 30.6899C336.176 30.533 336.129 30.3557 336.129 30.1752V15.6152C336.129 15.3394 336.238 15.0748 336.434 14.8798C336.629 14.6848 336.893 14.5752 337.169 14.5752C337.445 14.5752 337.709 14.6848 337.904 14.8798C338.099 15.0748 338.209 15.3394 338.209 15.6152V28.4176L346.3 23.8416C346.54 23.7069 346.824 23.6728 347.089 23.7469C347.354 23.821 347.579 23.9971 347.714 24.2368C347.85 24.4756 347.886 24.7583 347.814 25.0233C347.742 25.2883 347.568 25.514 347.33 25.6512L337.678 31.1112C337.519 31.1849 337.345 31.2205 337.169 31.2152Z",
    fill: "url(#paint1_linear_405_3876)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M101.796 269.001C99.9242 265.881 96.8458 268.595 96.8458 268.595C97.2826 262.688 91.8538 258.653 91.8538 258.653C91.8538 258.653 98.1666 258.653 99.0402 252.631C99.9138 246.61 96.8458 249.407 93.9546 249.366C91.0634 249.324 88.037 257.769 91.8746 262.522C95.7122 267.274 94.6618 275.386 85.853 283.186C83.7466 285.158 82.1664 287.625 81.2562 290.362C81.9218 283.197 82.2962 273.098 80.2162 266.359C76.6386 254.919 83.461 251.799 85.4162 246.1C87.3714 240.401 80.2162 235.534 80.2162 235.534C80.2162 235.534 86.9866 232.414 83.6794 228.93C80.3722 225.446 73.5498 225.882 73.5498 230.49C73.5498 235.097 78.1778 236.854 78.1778 236.854C78.1778 236.854 83.461 242.356 83.461 245.174C83.461 247.993 78.1778 254.202 78.1778 254.202C78.1778 254.202 80.601 248.929 75.7546 248.71C70.9082 248.492 69.369 254.867 71.3554 257.727C73.3418 260.587 76.6386 258.174 76.6386 258.174C76.8454 261.513 77.3501 264.826 78.1466 268.075C78.6458 269.729 78.417 276.187 78.001 282.906C77.0813 280.48 75.611 278.301 73.7058 276.541C64.897 268.741 63.8778 260.629 67.6946 255.876C71.5114 251.123 68.485 242.678 65.6146 242.72C62.7442 242.762 59.6346 239.954 60.5186 245.975C61.4026 251.997 67.7154 252.007 67.7154 252.007C67.7154 252.007 62.2762 256.042 62.713 261.95C62.713 261.95 59.593 259.266 57.7626 262.355C54.4242 267.857 62.1722 271.268 63.4722 268.595C63.4722 268.595 79.8938 280.222 75.9522 296.956L76.8674 298.318C76.753 299.67 76.6802 300.482 76.6802 300.482L77.9594 299.93L79.4258 302.083C79.3746 304.516 79.4997 306.949 79.8002 309.363L83.721 303.56C79.7586 286.826 96.201 275.199 96.201 275.199C97.397 277.924 105.135 274.502 101.796 269.001Z",
    fill: "#D2DEED"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.796 269.001C99.9242 265.881 96.8458 268.595 96.8458 268.595C97.2826 262.688 91.8538 258.653 91.8538 258.653C91.8538 258.653 98.1666 258.653 99.0402 252.631C99.9138 246.61 96.8458 249.407 93.9546 249.366C91.0634 249.324 88.037 257.769 91.8746 262.522C95.7122 267.274 94.6618 275.386 85.853 283.186C83.7466 285.158 82.1664 287.625 81.2562 290.362C81.9218 283.197 82.2962 273.098 80.2162 266.359C76.6386 254.919 83.461 251.799 85.4162 246.1C87.3714 240.401 80.2162 235.534 80.2162 235.534C80.2162 235.534 86.9866 232.414 83.6794 228.93C80.3722 225.446 73.5498 225.882 73.5498 230.49C73.5498 235.097 78.1778 236.854 78.1778 236.854C78.1778 236.854 83.461 242.356 83.461 245.174C83.461 247.993 78.1778 254.202 78.1778 254.202C78.1778 254.202 80.601 248.929 75.7546 248.71C70.9082 248.492 69.369 254.867 71.3554 257.727C73.3418 260.587 76.6386 258.174 76.6386 258.174C76.8454 261.513 77.3501 264.826 78.1466 268.075C78.6458 269.729 78.417 276.187 78.001 282.906C77.0813 280.48 75.611 278.301 73.7058 276.541C64.897 268.741 63.8778 260.629 67.6946 255.876C71.5114 251.123 68.485 242.678 65.6146 242.72C62.7442 242.762 59.6346 239.954 60.5186 245.975C61.4026 251.997 67.7154 252.007 67.7154 252.007C67.7154 252.007 62.2762 256.042 62.713 261.95C62.713 261.95 59.593 259.266 57.7626 262.355C54.4242 267.857 62.1722 271.268 63.4722 268.595C63.4722 268.595 79.8938 280.222 75.9522 296.956L76.8674 298.318C76.753 299.67 76.6802 300.482 76.6802 300.482L77.9594 299.93L79.4258 302.083C79.3746 304.516 79.4997 306.949 79.8002 309.363L83.721 303.56C79.7586 286.826 96.201 275.199 96.201 275.199C97.397 277.924 105.135 274.502 101.796 269.001Z",
    fill: "#05990A"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5825 340.386H60.9657L56.9097 299.202H102.649L98.5825 340.386Z",
    fill: "#CDE2FF"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M104.645 294.657H54.8916V303.747H104.645V294.657Z",
    fill: "#EBF5FF"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M260.989 387.477C372.355 387.477 462.634 382.207 462.634 375.705C462.634 369.203 372.355 363.932 260.989 363.932C149.623 363.932 59.3433 369.203 59.3433 375.705C59.3433 382.207 149.623 387.477 260.989 387.477Z",
    fill: "#F5F5F5"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M427.857 342.924C428.013 341.884 431.653 316.747 424.362 308.073C423.637 307.159 422.718 306.418 421.671 305.902C420.624 305.385 419.476 305.108 418.31 305.089C403.583 304.745 401.576 316.529 401.555 316.685L403.292 316.955C403.354 316.529 405.102 306.555 418.268 306.846C419.185 306.859 420.088 307.077 420.91 307.484C421.733 307.89 422.454 308.476 423.021 309.197C429.802 317.277 426.141 342.404 426.141 342.664L427.857 342.924Z",
    fill: "#5E453D"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M428.741 341.78L430.499 341.718C430.499 341.489 429.916 318.578 441.2 313.846C452.266 309.218 457.247 318.744 457.445 319.15L459.015 318.359C458.963 318.245 453.119 306.919 440.524 312.234C428.127 317.423 428.71 340.782 428.741 341.78Z",
    fill: "#5E453D"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M428.689 343.579C428.689 343.215 428.803 306.981 435.865 296.384C442.645 286.202 453.545 290.997 454.054 291.184L454.772 289.582C454.647 289.53 442.021 283.956 434.398 295.385C427.045 306.42 426.941 342.04 426.941 343.558L428.689 343.579Z",
    fill: "#5E453D"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M416.198 305.962C416.198 305.962 422.626 308.333 420.712 313.918C418.798 319.503 398.487 328.717 398.487 328.717C398.487 328.717 389.97 320.917 397.79 308.229C405.611 295.541 416.022 301.958 416.198 305.962Z",
    fill: "#06BF0D"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M436.176 294.47C436.176 294.47 431.621 293.981 432.016 291.205C432.412 288.428 449.759 281.273 460.003 292.837C460.003 292.837 453.44 304.111 443.956 304.277C434.471 304.444 436.176 294.47 436.176 294.47Z",
    fill: "#06BF0D"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M440.908 313.055C440.908 313.055 437.788 310.517 441.158 309.28C444.527 308.042 461.23 308.385 461.396 324.88C461.396 324.88 441.979 328.114 439.556 321.822C437.133 315.53 440.908 313.055 440.908 313.055Z",
    fill: "#06BF0D"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M416.198 305.962C416.198 305.962 422.626 308.333 420.712 313.918C418.798 319.503 398.487 328.717 398.487 328.717C398.487 328.717 389.97 320.917 397.79 308.229C405.611 295.541 416.022 301.958 416.198 305.962Z",
    fill: "black"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M436.176 294.47C436.176 294.47 431.621 293.981 432.016 291.205C432.412 288.428 449.759 281.273 460.003 292.837C460.003 292.837 453.44 304.111 443.956 304.277C434.471 304.444 436.176 294.47 436.176 294.47Z",
    fill: "black"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M440.908 313.055C440.908 313.055 437.788 310.517 441.158 309.28C444.527 308.042 461.23 308.385 461.396 324.88C461.396 324.88 441.979 328.114 439.556 321.822C437.133 315.53 440.908 313.055 440.908 313.055Z",
    fill: "black"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M412.745 376.568H442.885L446.129 343.579H409.5L412.745 376.568Z",
    fill: "url(#paint2_linear_405_3876)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M412.745 376.568H442.885L446.129 343.579H409.5L412.745 376.568Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M407.888 347.209H447.741V339.929H407.888V347.209Z",
    fill: "url(#paint3_linear_405_3876)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M407.888 347.209H447.741V339.929H407.888V347.209Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M378.634 352.918L348.671 349.975V307.855H336.794V349.954L306.749 352.918C305.308 353.06 303.971 353.733 302.999 354.805C302.026 355.878 301.487 357.274 301.486 358.722V363.225H383.938V358.722C383.938 357.267 383.394 355.864 382.412 354.79C381.431 353.716 380.083 353.048 378.634 352.918Z",
    fill: "#263238"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M378.634 352.918L348.671 349.975V307.855H336.794V349.954L306.749 352.918C305.308 353.06 303.971 353.733 302.999 354.805C302.026 355.878 301.487 357.274 301.486 358.722V363.225H383.938V358.722C383.938 357.267 383.394 355.864 382.412 354.79C381.431 353.716 380.083 353.048 378.634 352.918Z",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M304.617 376.579C308.908 376.579 312.386 373.1 312.386 368.81C312.386 364.519 308.908 361.041 304.617 361.041C300.326 361.041 296.848 364.519 296.848 368.81C296.848 373.1 300.326 376.579 304.617 376.579Z",
    fill: "#263238"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M380.735 376.579C385.025 376.579 388.503 373.1 388.503 368.81C388.503 364.519 385.025 361.041 380.735 361.041C376.444 361.041 372.966 364.519 372.966 368.81C372.966 373.1 376.444 376.579 380.735 376.579Z",
    fill: "#263238"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M334.756 279.401H350.72V312.608C350.72 313.747 350.267 314.84 349.462 315.645C348.656 316.451 347.564 316.903 346.425 316.903H339.051C337.912 316.903 336.819 316.451 336.014 315.645C335.208 314.84 334.756 313.747 334.756 312.608V279.401Z",
    fill: "#263238"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M334.756 279.401H350.72V312.608C350.72 313.747 350.267 314.84 349.462 315.645C348.656 316.451 347.564 316.903 346.425 316.903H339.051C337.912 316.903 336.819 316.451 336.014 315.645C335.208 314.84 334.756 313.747 334.756 312.608V279.401Z",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M371.124 213.579C371.124 213.579 373.392 269.739 357.75 279.401H375.607C375.607 279.401 389.439 260.275 385.528 213.579H371.124Z",
    fill: "#263238"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M371.124 213.579C371.124 213.579 373.392 269.739 357.75 279.401H375.607C375.607 279.401 389.439 260.275 385.528 213.579H371.124Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M381.681 283.707H301.684V276.749C301.684 275.37 302.232 274.047 303.207 273.072C304.183 272.097 305.505 271.549 306.884 271.549H376.481C377.86 271.549 379.183 272.097 380.158 273.072C381.133 274.047 381.681 275.37 381.681 276.749V283.707Z",
    fill: "#263238"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M300.436 283.707H382.918C384.073 283.707 385.009 282.771 385.009 281.616V279.723C385.009 278.569 384.073 277.633 382.918 277.633H300.436C299.282 277.633 298.346 278.569 298.346 279.723V281.616C298.346 282.771 299.282 283.707 300.436 283.707Z",
    fill: "#263238"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M300.436 283.707H382.918C384.073 283.707 385.009 282.771 385.009 281.616V279.723C385.009 278.569 384.073 277.633 382.918 277.633H300.436C299.282 277.633 298.346 278.569 298.346 279.723V281.616C298.346 282.771 299.282 283.707 300.436 283.707Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M389.908 183.471H361.308C352.933 183.471 346.145 190.26 346.145 198.634V209.825C346.145 218.199 352.933 224.988 361.308 224.988H389.908C398.282 224.988 405.071 218.199 405.071 209.825V198.634C405.071 190.26 398.282 183.471 389.908 183.471Z",
    fill: "#263238"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M274.56 137.586L268.85 122.538C268.85 122.538 271.304 120.27 269.62 117.972C267.935 115.674 257.41 109.215 255.496 110.349C253.583 111.482 249.308 115.767 251.617 118.149C253.926 120.53 264.097 124.493 264.097 124.493L269.152 144.253L274.56 137.586Z",
    fill: "#E4897B"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M314.423 166.197C314.423 166.197 288.423 160.862 285.646 159.582C282.869 158.303 272.428 127.696 272.428 127.696L264.409 131.44C264.409 131.44 270.857 162.162 277.451 169.462C284.044 176.763 312.187 182.982 312.187 182.982L314.423 166.197Z",
    fill: "url(#paint4_linear_405_3876)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.125 182.951L311.647 182.837C310.232 182.514 305.792 181.474 300.519 179.925C291.96 177.439 281.164 173.685 277.399 169.473C270.816 162.193 264.358 131.44 264.358 131.44L272.366 127.696C272.366 127.696 282.818 158.314 285.647 159.582C288.475 160.851 314.423 166.197 314.423 166.197L312.125 182.951Z",
    fill: "black"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M272.501 127.093L274.154 130.286L263.858 133.832L264.254 129.932L272.501 127.093Z",
    fill: "url(#paint5_linear_405_3876)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.323 182.525C310.887 182.317 306.384 181.62 300.997 180.445C304.065 175.141 313.051 172.416 313.051 172.416L312.323 182.525Z",
    fill: "black"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M351.032 145.001C351.032 145.001 352.561 159.385 347.236 162.921C341.911 166.457 315.693 162.317 312.718 156.525C309.744 150.732 320.934 135.028 320.934 135.028L351.032 145.001Z",
    fill: "#263238"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M244.961 334.261L251.804 335.915L255.267 326.471L258.408 317.881L250.619 314.563L247.623 324.984L244.961 334.261Z",
    fill: "#E4897B"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M247.624 324.984L255.268 326.471L258.409 317.881L250.619 314.563L247.624 324.984Z",
    fill: "black"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M248.31 320.002L257.795 323.528C257.795 323.528 283.098 260.265 288.298 260.088C293.498 259.911 346.444 284.206 359.715 270.706C372.985 257.207 353.797 224.655 353.797 224.655C353.797 224.655 321.88 220.1 319.477 227.307C318.886 229.432 318.434 231.593 318.125 233.776C317.761 235.981 317.512 237.832 317.512 237.832C316.524 237.583 284.481 229.315 271.856 237.832C259.012 246.495 248.31 320.002 248.31 320.002Z",
    fill: "url(#paint6_linear_405_3876)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M248.31 320.002L257.795 323.528C257.795 323.528 283.098 260.265 288.298 260.088C293.498 259.911 346.444 284.206 359.715 270.706C372.985 257.207 353.797 224.655 353.797 224.655C353.797 224.655 321.88 220.1 319.477 227.307C318.886 229.432 318.434 231.593 318.125 233.776C317.761 235.981 317.512 237.832 317.512 237.832C316.524 237.583 284.481 229.315 271.856 237.832C259.012 246.495 248.31 320.002 248.31 320.002Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M302.869 361.249L309.681 359.512L308.371 349.726L307.154 340.761L298.73 341.52L300.914 351.972L302.869 361.249Z",
    fill: "#E4897B"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M300.966 352.18L308.413 349.913L307.175 340.854L298.741 341.572L300.966 352.18Z",
    fill: "black"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M261.716 320.013L247.894 315.323L247.301 320.98L257.784 324.682L261.716 320.013Z",
    fill: "url(#paint7_linear_405_3876)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M336.793 273.91C336.793 273.91 334.63 273.962 301.153 272.402C301.153 272.402 306.155 314.251 308.89 345.587L298.875 347.292C298.875 347.292 274.955 280.202 275.215 269.542C275.475 258.882 287.695 255.762 287.695 255.762C287.695 255.762 311.542 269.542 336.793 273.91Z",
    fill: "url(#paint8_linear_405_3876)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M336.793 273.91C336.793 273.91 334.63 273.962 301.153 272.402C301.153 272.402 306.155 314.251 308.89 345.587L298.875 347.292C298.875 347.292 274.955 280.202 275.215 269.542C275.475 258.882 287.695 255.762 287.695 255.762C287.695 255.762 311.542 269.542 336.793 273.91Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M336.793 273.91C336.793 273.91 334.63 273.962 301.153 272.402C301.153 272.402 306.155 314.251 308.89 345.587L298.875 347.292C298.875 347.292 274.955 280.202 275.215 269.542C275.475 258.882 287.695 255.762 287.695 255.762C287.695 255.762 311.542 269.542 336.793 273.91Z",
    fill: "black"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M310.347 342.55L296.587 344.12L299.25 349.507L310.388 348.082L310.347 342.55Z",
    fill: "url(#paint9_linear_405_3876)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M317.512 237.832L336.18 241.721C336.18 241.721 325.863 236.022 318.126 233.776C317.762 235.981 317.512 237.832 317.512 237.832Z",
    fill: "black"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M353.028 219.694L353.798 224.655L319.478 227.307L318.573 221.431L353.028 219.694Z",
    fill: "#263238"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.028 219.694L353.798 224.655L319.478 227.307L318.573 221.431L353.028 219.694Z",
    fill: "black"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M342.204 228.006L343.9 227.831L343.012 219.193L341.316 219.367L342.204 228.006Z",
    fill: "url(#paint10_linear_405_3876)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M326.957 227.143L334.471 226.66L334.105 220.962L326.591 221.445L326.957 227.143Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M321.147 228.913L322.844 228.739L321.956 220.101L320.259 220.275L321.147 228.913Z",
    fill: "url(#paint11_linear_405_3876)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M342.204 228.006L343.9 227.831L343.012 219.193L341.316 219.367L342.204 228.006Z",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M321.147 228.913L322.844 228.739L321.956 220.101L320.259 220.275L321.147 228.913Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M313.799 165.729C320.228 167.505 326.899 168.238 333.559 167.902C344.584 167.341 357.708 172.655 357.708 172.655L352.987 219.663L318.521 221.4C318.521 221.4 306.987 182.182 313.799 165.729Z",
    fill: "url(#paint12_linear_405_3876)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M319.343 139.178C319.343 139.178 321.277 116.36 340.351 124.618C364.271 135.018 345.26 162.827 333.56 157.128C321.86 151.429 319.343 139.178 319.343 139.178Z",
    fill: "#263238"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324.688 169.182L325.24 182.078L329.514 176.014C329.514 176.014 327.985 190.273 328.88 198.042C328.88 198.042 329.701 184.116 331.636 176.014L336.18 182.078L342.701 169.265C342.701 169.265 332.145 165.469 324.688 169.182Z",
    fill: "black"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M330.596 171.615L340.465 168.828C334.381 164.668 337.449 155.308 337.449 155.308L327.673 158.74C328.123 160.099 328.47 161.489 328.713 162.9C329.753 168.994 326.987 169.483 326.987 169.483L330.596 171.615Z",
    fill: "#E4897B"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.673 158.688C328.123 160.047 328.471 161.437 328.713 162.848C333.393 160.966 337.439 155.235 337.439 155.235L327.673 158.688Z",
    fill: "black"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M334.059 129.443C325.395 127.53 321.579 131.523 318.979 140.322C315.723 151.294 316.441 159.759 327.787 159.78C343.2 159.801 348.431 132.626 334.059 129.443Z",
    fill: "#E4897B"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M324.678 141.081C323.703 142.22 322.593 143.237 321.371 144.107C321.546 144.524 321.833 144.883 322.2 145.146C322.567 145.409 323.001 145.564 323.451 145.594L324.678 141.081Z",
    fill: "#DE5753"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M330.138 141.539C329.961 142.246 330.2 142.922 330.679 143.036C331.157 143.151 331.667 142.672 331.843 141.996C332.02 141.32 331.781 140.623 331.303 140.499C330.824 140.374 330.315 140.831 330.138 141.539Z",
    fill: "#263238"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M331.49 140.55L330.107 139.573C330.107 139.573 330.554 141.06 331.49 140.55Z",
    fill: "#263238"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M321.381 139.229C321.205 139.937 321.444 140.613 321.922 140.727C322.401 140.841 322.962 140.363 323.087 139.687C323.212 139.011 323.025 138.314 322.546 138.189C322.068 138.065 321.558 138.522 321.381 139.229Z",
    fill: "#263238"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M322.733 138.242L321.309 137.295C321.309 137.295 321.797 138.741 322.733 138.242Z",
    fill: "#263238"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M335.016 138.096C334.946 138.097 334.878 138.08 334.817 138.045C334.757 138.01 334.707 137.959 334.673 137.898C334.33 137.363 333.872 136.912 333.332 136.577C332.792 136.243 332.184 136.033 331.553 135.964C331.454 135.951 331.363 135.901 331.299 135.824C331.236 135.746 331.204 135.648 331.21 135.548C331.22 135.448 331.27 135.356 331.348 135.291C331.425 135.227 331.525 135.196 331.626 135.205C332.392 135.279 333.131 135.53 333.784 135.938C334.438 136.345 334.987 136.899 335.391 137.555C335.414 137.599 335.428 137.648 335.432 137.698C335.436 137.747 335.43 137.798 335.415 137.845C335.399 137.893 335.374 137.936 335.342 137.974C335.309 138.012 335.269 138.043 335.224 138.065C335.158 138.091 335.087 138.102 335.016 138.096Z",
    fill: "#263238"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M325.333 134.175C325.263 134.174 325.194 134.152 325.136 134.113C324.624 133.867 324.065 133.74 323.498 133.74C322.93 133.74 322.371 133.867 321.86 134.113C321.815 134.131 321.766 134.14 321.718 134.14C321.669 134.139 321.621 134.129 321.576 134.11C321.532 134.09 321.492 134.062 321.458 134.027C321.424 133.992 321.398 133.95 321.381 133.905C321.363 133.859 321.353 133.81 321.354 133.761C321.354 133.711 321.364 133.662 321.383 133.617C321.403 133.572 321.431 133.53 321.466 133.496C321.501 133.461 321.543 133.434 321.589 133.416C322.21 133.127 322.89 132.984 323.575 132.998C324.26 133.013 324.933 133.184 325.541 133.499C325.583 133.526 325.619 133.56 325.648 133.601C325.676 133.641 325.696 133.687 325.707 133.735C325.718 133.784 325.718 133.834 325.71 133.882C325.701 133.931 325.682 133.977 325.656 134.019C325.618 134.069 325.57 134.11 325.514 134.137C325.457 134.164 325.395 134.177 325.333 134.175Z",
    fill: "#263238"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M340.288 146.125C340.288 146.125 337.813 138.117 339.644 132.761C339.644 132.761 324.044 121.955 319.343 139.178C319.343 139.178 321.08 123.349 336.045 126.302C351.011 129.256 346.112 151.002 336.992 155.786C336.992 155.786 341.807 151.127 340.288 146.125Z",
    fill: "#263238"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M338.469 147.695C338.773 146.711 339.455 145.888 340.366 145.407C341.276 144.925 342.341 144.824 343.325 145.126C345.946 146.01 345.998 151.803 339.041 151.647C338.032 151.574 337.699 150.524 338.469 147.695Z",
    fill: "#E4897B"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M321.88 148.881C322.112 149.943 322.265 151.02 322.338 152.105H322.9C325.489 152.323 326.758 151.564 327.382 150.67C327.68 150.225 327.866 149.715 327.923 149.182C327.967 148.882 327.967 148.578 327.923 148.278C326.253 148.853 324.48 149.062 322.723 148.891C322.224 148.922 321.88 148.881 321.88 148.881Z",
    fill: "#263238"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M322.764 148.943L322.92 149.89C325.354 150.087 327.08 149.89 327.923 149.234C327.967 148.934 327.967 148.63 327.923 148.33C326.266 148.899 324.508 149.108 322.764 148.943Z",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M322.899 152.157C325.489 152.375 326.758 151.616 327.382 150.721C326.4 150.657 325.414 150.766 324.47 151.044C323.842 151.24 323.293 151.629 322.899 152.157Z",
    fill: "#DE5753"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M334.09 130.14C334.09 130.14 334.423 145.147 343.45 146.957C352.477 148.766 342.618 127.654 342.618 127.654C342.618 127.654 329.202 118.898 320.258 125.075C311.314 131.253 319.364 139.178 319.364 139.178C319.364 139.178 321.225 128.029 334.09 130.14Z",
    fill: "#263238"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M337.533 143.878C337.471 143.878 337.413 143.856 337.366 143.816C330.96 138.782 334.121 129.152 334.153 129.058C334.176 128.993 334.224 128.94 334.286 128.909C334.348 128.878 334.419 128.872 334.485 128.892C334.55 128.916 334.603 128.964 334.632 129.026C334.662 129.089 334.665 129.16 334.641 129.225C334.641 129.318 331.573 138.585 337.689 143.41C337.713 143.434 337.733 143.462 337.747 143.493C337.76 143.525 337.767 143.558 337.767 143.592C337.767 143.627 337.76 143.66 337.747 143.692C337.733 143.723 337.713 143.751 337.689 143.774C337.671 143.802 337.649 143.825 337.622 143.843C337.595 143.861 337.564 143.873 337.533 143.878Z",
    fill: "#263238"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M346.06 150.035C344.916 153.093 341.973 154.809 339.488 153.883C337.002 152.958 335.92 149.723 337.064 146.666C338.208 143.608 341.152 141.892 343.637 142.828C346.123 143.764 347.204 146.988 346.06 150.035Z",
    fill: "url(#paint13_linear_405_3876)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M346.06 150.035C344.916 153.093 341.973 154.809 339.488 153.883C337.002 152.958 335.92 149.723 337.064 146.666C338.208 143.608 341.152 141.892 343.637 142.828C346.123 143.764 347.204 146.988 346.06 150.035Z",
    fill: "black"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M343.148 145.033C343.148 145.033 346.882 128.32 338.51 123.942C339.463 124.066 340.408 124.25 341.339 124.493C342.379 124.805 349.107 131.586 345.727 146.603L343.148 145.033Z",
    fill: "url(#paint14_linear_405_3876)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M343.148 145.033C343.148 145.033 346.882 128.32 338.51 123.942C339.463 124.066 340.408 124.25 341.339 124.493C342.379 124.805 349.107 131.586 345.727 146.603L343.148 145.033Z",
    fill: "black"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M327.548 154.601L326.924 154.507L327.09 153.467C331.683 154.174 336.376 153.179 340.288 150.67L340.901 151.502C336.968 154.108 332.227 155.208 327.548 154.601Z",
    fill: "url(#paint15_linear_405_3876)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.548 154.601L326.924 154.507L327.09 153.467C331.683 154.174 336.376 153.179 340.288 150.67L340.901 151.502C336.968 154.108 332.227 155.208 327.548 154.601Z",
    fill: "black"
  }))), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M345.707 149.619C344.958 151.637 343.003 152.739 341.37 152.157C339.737 151.574 339.009 149.411 339.768 147.394C340.528 145.376 342.472 144.274 344.105 144.856C345.738 145.438 346.466 147.602 345.707 149.619Z",
    fill: "url(#paint16_linear_405_3876)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M326.571 154.975L325.728 154.861C325.581 154.842 325.44 154.793 325.311 154.719C325.183 154.645 325.07 154.546 324.98 154.428C324.891 154.31 324.825 154.175 324.787 154.032C324.75 153.888 324.741 153.739 324.761 153.592C324.779 153.444 324.826 153.301 324.9 153.171C324.974 153.042 325.073 152.928 325.191 152.837C325.309 152.746 325.444 152.68 325.588 152.641C325.732 152.603 325.882 152.594 326.03 152.614L326.862 152.729C327.159 152.77 327.427 152.926 327.61 153.164C327.793 153.401 327.875 153.7 327.84 153.998C327.798 154.294 327.642 154.563 327.405 154.745C327.168 154.928 326.868 155.011 326.571 154.975Z",
    fill: "url(#paint17_linear_405_3876)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M326.571 154.975L325.728 154.861C325.581 154.842 325.44 154.793 325.311 154.719C325.183 154.645 325.07 154.546 324.98 154.428C324.891 154.31 324.825 154.175 324.787 154.032C324.75 153.888 324.741 153.739 324.761 153.592C324.779 153.444 324.826 153.301 324.9 153.171C324.974 153.042 325.073 152.928 325.191 152.837C325.309 152.746 325.444 152.68 325.588 152.641C325.732 152.603 325.882 152.594 326.03 152.614L326.862 152.729C327.159 152.77 327.427 152.926 327.61 153.164C327.793 153.401 327.875 153.7 327.84 153.998C327.798 154.294 327.642 154.563 327.405 154.745C327.168 154.928 326.868 155.011 326.571 154.975Z",
    fill: "black"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M337.813 165.219L331.636 171.282L334.111 178.729L342.701 169.265L337.813 165.219Z",
    fill: "url(#paint18_linear_405_3876)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M328.88 166.488L329.878 171.157L326.685 177.761L324.688 169.181L328.88 166.488Z",
    fill: "url(#paint19_linear_405_3876)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M336.493 170.482L340.081 157.346C340.081 157.346 338.344 154.081 338.718 153.394C339.093 152.708 340.965 143.889 342.296 142.932C343.627 141.975 349.108 143.608 349.659 144.502C350.21 145.397 344.407 157.346 344.407 157.346L342.327 171.584L336.493 170.482Z",
    fill: "#E4897B"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M357.708 172.655C367.588 182.764 347.797 205.665 336.45 204.687C325.104 203.709 336.742 162.193 336.742 162.193L344.022 163.389C344.022 163.389 341.474 181.36 342.274 182.764C343.075 184.168 354.432 169.296 357.708 172.655Z",
    fill: "url(#paint20_linear_405_3876)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.708 172.655C367.588 182.764 347.797 205.665 336.45 204.687C325.104 203.709 336.742 162.193 336.742 162.193L344.022 163.389C344.022 163.389 341.474 181.36 342.274 182.764C343.075 184.168 354.432 169.296 357.708 172.655Z",
    fill: "black"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M336.18 160.893L335.109 164.325L345.228 165.219V162.224L336.18 160.893Z",
    fill: "url(#paint21_linear_405_3876)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M320.841 188.047H316.743C316.289 188.047 315.921 188.415 315.921 188.869V196.606C315.921 197.06 316.289 197.428 316.743 197.428H320.841C321.294 197.428 321.662 197.06 321.662 196.606V188.869C321.662 188.415 321.294 188.047 320.841 188.047Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M320.923 188.671H316.264V195.046H320.923V188.671Z",
    fill: "black"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M319.218 185.79H318.188V189.545H319.218V185.79Z",
    fill: "#263238"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M233.646 347.552C234.684 347.07 235.801 346.784 236.943 346.71C236.943 346.71 240.895 344.391 244.805 335.353H249.205C249.951 335.358 250.677 335.594 251.284 336.028C251.89 336.461 252.349 337.072 252.595 337.776C252.668 337.969 252.711 338.173 252.72 338.379C252.668 339.443 252.553 340.502 252.377 341.551C251.733 345.067 250.875 348.54 249.808 351.951L249.059 351.764L250.411 345.191C250.869 342.966 248.518 345.119 247.437 347.365C246.355 349.611 244.681 351.889 239.813 350.776C234.145 349.383 231.868 348.571 233.646 347.552Z",
    fill: "url(#paint22_linear_405_3876)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M245.607 332.992C245.607 332.992 240.105 344.495 236.943 346.71C236.943 346.71 241.187 349.237 245.607 343.59C251.316 336.31 252.72 338.338 252.72 338.338C252.6 337.082 252.367 335.839 252.023 334.625C251.171 332.295 245.607 332.992 245.607 332.992Z",
    fill: "#E4897B"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M294.195 374.956C295.094 374.248 296.112 373.705 297.201 373.355C297.201 373.355 300.487 370.162 302.141 360.458L306.415 359.418C307.141 359.251 307.9 359.312 308.59 359.591C309.281 359.87 309.868 360.354 310.274 360.978C310.391 361.152 310.482 361.341 310.544 361.54C310.752 362.57 310.895 363.612 310.971 364.66C311.171 368.215 311.153 371.778 310.919 375.331H310.149L309.91 368.633C309.816 366.355 308.059 369.007 307.528 371.451C306.998 373.895 305.927 376.485 300.935 376.558C295.121 376.62 292.708 376.37 294.195 374.956Z",
    fill: "url(#paint23_linear_405_3876)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M302.36 357.973C302.36 357.973 299.749 370.453 297.16 373.354C297.16 373.354 301.881 374.81 304.835 368.289C308.662 359.865 310.503 361.509 310.503 361.509C310.092 360.317 309.573 359.164 308.953 358.066C307.601 355.986 302.36 357.973 302.36 357.973Z",
    fill: "#E4897B"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M399.059 106.251H362.753C359.841 106.251 357.48 108.612 357.48 111.524V127.051C357.48 129.963 359.841 132.324 362.753 132.324H399.059C401.971 132.324 404.332 129.963 404.332 127.051V111.524C404.332 108.612 401.971 106.251 399.059 106.251Z",
    fill: "url(#paint24_linear_405_3876)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M370.033 129.35L359.092 144.222L376.741 130.348L370.033 129.35Z",
    fill: "url(#paint25_linear_405_3876)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M370.438 119.282C370.44 119.588 370.351 119.887 370.183 120.141C370.014 120.396 369.774 120.595 369.492 120.713C369.211 120.83 368.9 120.862 368.601 120.803C368.301 120.744 368.026 120.597 367.81 120.381C367.594 120.165 367.448 119.89 367.388 119.59C367.329 119.291 367.361 118.98 367.479 118.699C367.596 118.417 367.795 118.177 368.05 118.009C368.305 117.84 368.604 117.751 368.909 117.753C369.314 117.753 369.703 117.915 369.99 118.201C370.277 118.488 370.438 118.877 370.438 119.282Z",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M378.436 119.282C378.438 119.588 378.349 119.887 378.181 120.141C378.012 120.396 377.772 120.595 377.49 120.713C377.209 120.83 376.898 120.862 376.599 120.803C376.299 120.744 376.024 120.597 375.808 120.381C375.592 120.165 375.446 119.89 375.386 119.59C375.327 119.291 375.359 118.98 375.477 118.699C375.594 118.417 375.793 118.177 376.048 118.009C376.303 117.84 376.602 117.751 376.907 117.753C377.312 117.753 377.701 117.915 377.988 118.201C378.275 118.488 378.436 118.877 378.436 119.282Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M386.434 119.282C386.436 119.588 386.347 119.887 386.179 120.141C386.01 120.396 385.77 120.595 385.488 120.713C385.207 120.83 384.896 120.862 384.597 120.803C384.297 120.744 384.022 120.597 383.806 120.381C383.59 120.165 383.444 119.89 383.385 119.59C383.325 119.291 383.357 118.98 383.475 118.699C383.592 118.417 383.791 118.177 384.046 118.009C384.301 117.84 384.6 117.751 384.905 117.753C385.31 117.753 385.699 117.915 385.986 118.201C386.273 118.488 386.434 118.877 386.434 119.282Z",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M394.431 119.282C394.433 119.588 394.344 119.887 394.176 120.141C394.008 120.396 393.767 120.595 393.486 120.713C393.204 120.83 392.894 120.862 392.594 120.803C392.294 120.744 392.019 120.597 391.803 120.381C391.587 120.165 391.441 119.89 391.382 119.59C391.323 119.291 391.354 118.98 391.472 118.699C391.589 118.417 391.788 118.177 392.043 118.009C392.298 117.84 392.597 117.751 392.902 117.753C393.308 117.753 393.696 117.915 393.983 118.201C394.27 118.488 394.431 118.877 394.431 119.282Z",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M262.729 93.9561L236.826 80.0031C236.128 79.6272 235.258 79.8882 234.882 80.5861L226.616 95.9317C226.24 96.6295 226.501 97.5 227.199 97.8759L253.101 111.829C253.799 112.205 254.669 111.944 255.045 111.246L263.312 95.9003C263.687 95.2024 263.426 94.332 262.729 93.9561Z",
    fill: "#529DB5"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M262.729 93.9561L236.826 80.0031C236.128 79.6272 235.258 79.8882 234.882 80.5861L226.616 95.9317C226.24 96.6295 226.501 97.5 227.199 97.8759L253.101 111.829C253.799 112.205 254.669 111.944 255.045 111.246L263.312 95.9003C263.687 95.2024 263.426 94.332 262.729 93.9561Z",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M234.208 81.8528L242.268 96.9848C242.577 97.5612 243.051 98.0329 243.629 98.3402C244.206 98.6475 244.862 98.7766 245.513 98.7112L262.371 97.0472L245.211 99.5744C244.461 99.6853 243.696 99.5508 243.028 99.1909C242.361 98.8311 241.828 98.2651 241.509 97.5776L234.208 81.8528Z",
    fill: "black"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M214.541 79.0552C214.822 73.2728 219.107 61.6144 224.317 58.0472C229.528 54.48 226.096 59.42 226.096 59.42C226.096 59.42 231.036 54.6152 233.636 54.7608C236.236 54.9064 233.636 57.8808 233.636 57.8808C233.636 57.8808 238.992 54.584 241.457 54.7608C243.921 54.9376 241.457 57.7872 241.457 57.7872C241.457 57.7872 245.845 54.6672 247.624 56.1336C249.402 57.6 224.858 73.8136 222.123 80.4072C219.388 87.0008 214.261 84.8896 214.541 79.0552Z",
    fill: "url(#paint26_linear_405_3876)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M214.541 79.0552C214.822 73.2728 219.107 61.6144 224.317 58.0472C229.528 54.48 226.096 59.42 226.096 59.42C226.096 59.42 231.036 54.6152 233.636 54.7608C236.236 54.9064 233.636 57.8808 233.636 57.8808C233.636 57.8808 238.992 54.584 241.457 54.7608C243.921 54.9376 241.457 57.7872 241.457 57.7872C241.457 57.7872 245.845 54.6672 247.624 56.1336C249.402 57.6 224.858 73.8136 222.123 80.4072C219.388 87.0008 214.261 84.8896 214.541 79.0552Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M235.633 78.1816L238.909 80.2616C238.961 80.2937 239 80.3423 239.021 80.3995C239.041 80.4567 239.042 80.5193 239.023 80.577C239.004 80.6347 238.966 80.6843 238.915 80.7177C238.864 80.751 238.803 80.7662 238.742 80.7608L235.3 80.4904L235.591 83.132C235.6 83.1943 235.588 83.2577 235.557 83.3126C235.527 83.3676 235.479 83.4112 235.422 83.4369C235.365 83.4627 235.3 83.4692 235.239 83.4555C235.178 83.4417 235.123 83.4086 235.082 83.3608L233.095 81.1352L235.633 78.1816Z",
    fill: "url(#paint27_linear_405_3876)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M235.633 78.1816L238.909 80.2616C238.961 80.2937 239 80.3423 239.021 80.3995C239.041 80.4567 239.042 80.5193 239.023 80.577C239.004 80.6347 238.966 80.6843 238.915 80.7177C238.864 80.751 238.803 80.7662 238.742 80.7608L235.3 80.4904L235.591 83.132C235.6 83.1943 235.588 83.2577 235.557 83.3126C235.527 83.3676 235.479 83.4112 235.422 83.4369C235.365 83.4627 235.3 83.4692 235.239 83.4555C235.178 83.4417 235.123 83.4086 235.082 83.3608L233.095 81.1352L235.633 78.1816Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M189.613 65.1608C189.613 65.1608 194.147 62.0408 201.001 64.0584C201.001 64.0584 202.966 73.1168 208.364 76.1328C211.328 77.7864 218.577 77.6408 224.318 75.7896C231.13 73.5848 234.458 73.5848 235.695 76.1328C236.933 78.6808 235.56 81.3328 230.35 82.5704C225.139 83.808 220.99 92.856 211.557 92.9704C202.124 93.0848 197.111 83.6104 199.493 75.2904C197.238 71.0371 193.809 67.5211 189.613 65.1608Z",
    fill: "url(#paint28_linear_405_3876)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.613 65.1608C189.613 65.1608 194.147 62.0408 201.001 64.0584C201.001 64.0584 202.966 73.1168 208.364 76.1328C211.328 77.7864 218.577 77.6408 224.318 75.7896C231.13 73.5848 234.458 73.5848 235.695 76.1328C236.933 78.6808 235.56 81.3328 230.35 82.5704C225.139 83.808 220.99 92.856 211.557 92.9704C202.124 93.0848 197.111 83.6104 199.493 75.2904C197.238 71.0371 193.809 67.5211 189.613 65.1608Z",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M233.095 77.8489C233.095 77.9414 233.068 78.0319 233.016 78.1089C232.965 78.1858 232.892 78.2458 232.806 78.2812C232.721 78.3167 232.627 78.3259 232.536 78.3079C232.445 78.2898 232.362 78.2452 232.296 78.1798C232.231 78.1143 232.186 78.0309 232.168 77.9402C232.15 77.8494 232.159 77.7553 232.195 77.6698C232.23 77.5842 232.29 77.5112 232.367 77.4597C232.444 77.4083 232.535 77.3809 232.627 77.3809C232.751 77.3809 232.87 77.4302 232.958 77.5179C233.046 77.6057 233.095 77.7247 233.095 77.8489Z",
    fill: "#263238"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M209.363 85.4617C203.778 86.9801 191.36 86.5017 186.368 82.6537C181.376 78.8057 187.117 80.5737 187.117 80.5737C187.117 80.5737 181.033 77.3601 180.357 74.8433C179.681 72.3265 183.352 73.8657 183.352 73.8657C183.352 73.8657 178.568 69.7993 177.944 67.4073C177.32 65.0153 180.815 66.4713 180.815 66.4713C180.815 66.4713 176.457 63.2681 177.341 61.1153C178.225 58.9625 201.199 77.3081 208.302 77.8801C215.405 78.4521 215.02 83.9225 209.363 85.4617Z",
    fill: "url(#paint29_linear_405_3876)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M209.363 85.4617C203.778 86.9801 191.36 86.5017 186.368 82.6537C181.376 78.8057 187.117 80.5737 187.117 80.5737C187.117 80.5737 181.033 77.3601 180.357 74.8433C179.681 72.3265 183.352 73.8657 183.352 73.8657C183.352 73.8657 178.568 69.7993 177.944 67.4073C177.32 65.0153 180.815 66.4713 180.815 66.4713C180.815 66.4713 176.457 63.2681 177.341 61.1153C178.225 58.9625 201.199 77.3081 208.302 77.8801C215.405 78.4521 215.02 83.9225 209.363 85.4617Z",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M172.754 60.1582C172.713 60.1683 172.67 60.1683 172.629 60.1582C171.662 59.815 170.674 59.4926 169.676 59.191C169.577 59.1598 169.494 59.0912 169.446 58.9997C169.397 58.9083 169.386 58.8015 169.416 58.7022C169.447 58.6035 169.515 58.5209 169.607 58.4723C169.698 58.4237 169.805 58.4129 169.904 58.4422C170.944 58.7438 171.912 59.0766 172.889 59.4822C172.976 59.512 173.05 59.572 173.097 59.6513C173.143 59.7307 173.16 59.8241 173.144 59.9147C173.127 60.0053 173.079 60.0871 173.007 60.1451C172.936 60.2031 172.846 60.2336 172.754 60.231V60.1582Z",
    fill: "url(#paint30_linear_405_3876)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M109.897 144.575C109.794 144.575 109.695 144.535 109.621 144.463C109.547 144.391 109.504 144.293 109.502 144.19C109.502 144.087 109.542 143.988 109.614 143.914C109.685 143.841 109.783 143.798 109.886 143.795C111.955 143.766 114.018 143.564 116.054 143.192C116.155 143.174 116.261 143.196 116.346 143.254C116.432 143.313 116.491 143.402 116.511 143.504C116.522 143.554 116.522 143.607 116.512 143.657C116.502 143.708 116.481 143.756 116.452 143.799C116.423 143.842 116.386 143.878 116.342 143.906C116.299 143.934 116.25 143.953 116.199 143.961C114.119 144.342 112.011 144.547 109.897 144.575ZM103.657 144.242C101.558 144.018 99.4745 143.671 97.4167 143.202C97.3149 143.18 97.226 143.118 97.1695 143.03C97.113 142.943 97.0935 142.836 97.1151 142.734C97.1399 142.634 97.2026 142.548 97.29 142.494C97.3774 142.439 97.4826 142.421 97.5831 142.443C99.6084 142.899 101.657 143.246 103.719 143.483C103.812 143.498 103.896 143.546 103.956 143.617C104.017 143.689 104.05 143.779 104.05 143.873C104.05 143.967 104.017 144.058 103.956 144.129C103.896 144.2 103.812 144.248 103.719 144.263L103.657 144.242ZM122.138 142.162C122.063 142.163 121.989 142.141 121.927 142.101C121.864 142.06 121.814 142.002 121.784 141.933C121.762 141.887 121.749 141.836 121.747 141.784C121.745 141.732 121.753 141.68 121.772 141.631C121.79 141.583 121.818 141.538 121.854 141.501C121.89 141.463 121.934 141.434 121.982 141.413C123.87 140.599 125.624 139.502 127.182 138.158C127.261 138.098 127.361 138.069 127.461 138.079C127.56 138.089 127.652 138.137 127.718 138.212C127.784 138.287 127.819 138.385 127.816 138.485C127.813 138.585 127.772 138.68 127.702 138.751C126.081 140.141 124.262 141.28 122.304 142.131C122.247 142.163 122.182 142.181 122.117 142.183L122.138 142.162ZM91.4679 141.455C91.427 141.465 91.3841 141.465 91.3431 141.455C89.3671 140.8 87.3807 140.03 85.4567 139.188C85.3715 139.139 85.3074 139.06 85.277 138.967C85.2466 138.874 85.2521 138.772 85.2923 138.683C85.3326 138.593 85.4047 138.522 85.4947 138.483C85.5847 138.443 85.6861 138.439 85.7791 138.47C87.6719 139.302 89.6271 140.061 91.5927 140.717C91.6901 140.752 91.7696 140.824 91.8143 140.917C91.8591 141.011 91.8654 141.118 91.8319 141.216C91.8025 141.288 91.752 141.349 91.687 141.392C91.6221 141.435 91.5457 141.457 91.4679 141.455ZM80.0279 136.401C79.9669 136.419 79.9018 136.419 79.8407 136.401C77.9791 135.361 76.1695 134.237 74.4847 133.062C74.4431 133.033 74.4076 132.996 74.3804 132.953C74.3531 132.91 74.3346 132.861 74.3259 132.811C74.3173 132.761 74.3185 132.71 74.3297 132.66C74.3409 132.61 74.3618 132.563 74.3911 132.521C74.4205 132.48 74.4578 132.444 74.5009 132.417C74.5439 132.39 74.5919 132.371 74.6422 132.363C74.6924 132.354 74.7438 132.355 74.7935 132.366C74.8433 132.378 74.8903 132.399 74.9319 132.428C76.5959 133.582 78.3743 134.695 80.2255 135.725C80.2703 135.75 80.3097 135.783 80.3414 135.823C80.373 135.864 80.3963 135.91 80.4099 135.959C80.4234 136.009 80.427 136.06 80.4203 136.111C80.4137 136.162 80.397 136.211 80.3711 136.255C80.3272 136.323 80.2641 136.375 80.1901 136.407C80.116 136.438 80.0342 136.447 79.9551 136.432L80.0279 136.401ZM131.446 134.019C131.385 134.038 131.319 134.038 131.258 134.019C131.214 133.994 131.174 133.961 131.143 133.92C131.111 133.88 131.088 133.834 131.074 133.785C131.06 133.735 131.057 133.683 131.064 133.633C131.07 133.582 131.087 133.533 131.113 133.489C131.435 132.927 131.737 132.345 132.007 131.741C132.586 130.468 133.039 129.141 133.359 127.779C133.386 127.678 133.451 127.592 133.54 127.538C133.629 127.483 133.736 127.466 133.838 127.488C133.938 127.515 134.023 127.58 134.076 127.67C134.129 127.759 134.144 127.866 134.118 127.966C133.779 129.373 133.309 130.745 132.714 132.064C132.434 132.688 132.122 133.301 131.789 133.884C131.744 133.95 131.681 134.002 131.607 134.032C131.532 134.061 131.451 134.068 131.373 134.05L131.446 134.019ZM69.7735 129.214C69.682 129.213 69.5938 129.18 69.5239 129.121C67.9401 127.722 66.4562 126.213 65.0831 124.607C65.0114 124.533 64.9712 124.434 64.9712 124.331C64.9712 124.229 65.0114 124.13 65.0831 124.056C65.1552 123.985 65.2523 123.945 65.3535 123.945C65.4548 123.945 65.5519 123.985 65.6239 124.056C66.9722 125.629 68.4282 127.105 69.9815 128.476C70.0533 128.55 70.0935 128.649 70.0935 128.751C70.0935 128.854 70.0533 128.953 69.9815 129.027C69.9558 129.083 69.9168 129.133 69.8679 129.171C69.819 129.209 69.7617 129.234 69.7007 129.245L69.7735 129.214ZM134.441 121.997C134.389 121.997 134.338 121.986 134.291 121.966C134.244 121.946 134.201 121.917 134.165 121.88C134.129 121.843 134.101 121.8 134.082 121.752C134.063 121.704 134.055 121.653 134.056 121.601C134.041 119.533 133.849 117.47 133.484 115.434C133.466 115.332 133.488 115.227 133.546 115.142C133.605 115.056 133.694 114.997 133.796 114.977C133.899 114.961 134.004 114.986 134.089 115.046C134.174 115.106 134.233 115.197 134.254 115.299C134.628 117.379 134.823 119.488 134.836 121.601C134.836 121.706 134.794 121.807 134.72 121.881C134.646 121.955 134.546 121.997 134.441 121.997ZM132.361 109.662C132.277 109.661 132.195 109.634 132.128 109.583C132.06 109.533 132.011 109.462 131.986 109.381C131.456 107.561 130.801 105.627 130 103.464C129.98 103.416 129.97 103.364 129.971 103.311C129.972 103.259 129.983 103.208 130.005 103.16C130.026 103.112 130.057 103.069 130.096 103.034C130.134 102.999 130.179 102.972 130.229 102.954C130.325 102.92 130.431 102.925 130.525 102.968C130.618 103.011 130.691 103.088 130.728 103.183C131.539 105.367 132.194 107.343 132.735 109.153C132.764 109.252 132.754 109.359 132.705 109.45C132.656 109.542 132.574 109.61 132.475 109.641L132.361 109.662ZM128.055 97.8583C127.983 97.8588 127.912 97.8385 127.851 97.7998C127.79 97.761 127.742 97.7055 127.712 97.6399C127.046 95.9759 126.142 94.0623 125.195 92.0343V91.9303C125.168 91.8396 125.174 91.7423 125.213 91.6559C125.252 91.5695 125.32 91.4998 125.406 91.4595C125.491 91.4192 125.588 91.411 125.68 91.4363C125.771 91.4617 125.85 91.5188 125.902 91.5975V91.7015C126.859 93.7815 127.754 95.6639 128.419 97.2967C128.461 97.3947 128.463 97.5053 128.424 97.6046C128.385 97.7038 128.309 97.7838 128.211 97.8271L128.055 97.8583ZM122.855 86.4183C122.779 86.4207 122.703 86.4002 122.638 86.3595C122.573 86.3187 122.522 86.2595 122.491 86.1895C121.555 84.0159 120.806 82.0919 120.214 80.3135C120.18 80.2155 120.186 80.1084 120.231 80.015C120.276 79.9217 120.355 79.8496 120.453 79.8143C120.552 79.7813 120.66 79.7891 120.754 79.8359C120.848 79.8827 120.919 79.9647 120.952 80.0639C121.534 81.8215 122.273 83.7247 123.209 85.8775C123.229 85.9245 123.24 85.9752 123.241 86.0265C123.241 86.0777 123.231 86.1286 123.212 86.1761C123.193 86.2235 123.164 86.2667 123.128 86.3029C123.091 86.3391 123.048 86.3678 123.001 86.3871C122.966 86.424 122.923 86.4524 122.876 86.4703L122.855 86.4183ZM119.049 74.4999C118.956 74.4986 118.866 74.4645 118.796 74.4036C118.725 74.3428 118.679 74.259 118.664 74.1671C118.485 73.0527 118.395 71.9261 118.394 70.7975C118.385 69.7892 118.476 68.7825 118.664 67.7919C118.694 67.6996 118.757 67.6216 118.841 67.5727C118.924 67.5238 119.023 67.5074 119.118 67.5267C119.213 67.546 119.298 67.5996 119.356 67.6772C119.414 67.7549 119.442 67.8512 119.434 67.9479C119.254 68.8869 119.166 69.8414 119.174 70.7975C119.177 71.8876 119.264 72.9758 119.434 74.0527C119.446 74.1541 119.42 74.2566 119.36 74.3395C119.3 74.4224 119.211 74.4797 119.111 74.4999H119.049ZM121.763 62.6855C121.673 62.688 121.584 62.6585 121.514 62.6023C121.442 62.5285 121.402 62.4296 121.402 62.3267C121.402 62.2238 121.442 62.1249 121.514 62.0511C122.91 60.4199 124.608 59.0744 126.516 58.0887C126.607 58.0402 126.714 58.0293 126.813 58.0585C126.912 58.0877 126.996 58.1545 127.046 58.2447C127.091 58.3377 127.099 58.4443 127.068 58.5429C127.037 58.6414 126.97 58.7245 126.88 58.7751C125.064 59.7144 123.446 60.9964 122.117 62.5503C122.082 62.6078 122.034 62.6553 121.975 62.6881C121.917 62.7209 121.851 62.7379 121.784 62.7375L121.763 62.6855ZM163.696 57.5895H163.613C161.616 57.1735 159.546 56.8199 157.456 56.5495C157.405 56.5431 157.356 56.5267 157.312 56.5012C157.268 56.4757 157.229 56.4416 157.198 56.4009C157.167 56.3602 157.144 56.3138 157.132 56.2643C157.119 56.2148 157.116 56.1633 157.123 56.1127C157.13 56.062 157.146 56.013 157.171 55.9687C157.197 55.9244 157.231 55.8856 157.272 55.8547C157.312 55.8237 157.359 55.8011 157.408 55.7883C157.458 55.7754 157.509 55.7726 157.56 55.7799C159.64 56.0503 161.72 56.4039 163.8 56.8199C163.893 56.8414 163.976 56.896 164.032 56.9736C164.088 57.0511 164.114 57.1464 164.105 57.2417C164.096 57.337 164.053 57.4259 163.983 57.4918C163.914 57.5576 163.823 57.5961 163.727 57.5999L163.696 57.5895ZM132.496 56.7055C132.445 56.711 132.394 56.7064 132.346 56.6921C132.297 56.6778 132.251 56.6541 132.212 56.6222C132.172 56.5903 132.139 56.551 132.115 56.5064C132.09 56.4618 132.075 56.4128 132.07 56.3623C132.064 56.3118 132.069 56.2606 132.083 56.2119C132.097 56.1631 132.121 56.1176 132.153 56.078C132.185 56.0384 132.224 56.0055 132.269 55.9811C132.313 55.9567 132.362 55.9414 132.413 55.9359C134.467 55.4751 136.553 55.1726 138.653 55.0311C138.756 55.0253 138.857 55.0602 138.935 55.1283C139.013 55.1963 139.061 55.2921 139.069 55.3951C139.073 55.4465 139.067 55.4982 139.051 55.5472C139.035 55.5961 139.009 55.6414 138.975 55.6802C138.941 55.719 138.899 55.7506 138.853 55.7731C138.807 55.7955 138.756 55.8085 138.705 55.8111C136.639 55.9446 134.588 56.2402 132.569 56.6951L132.496 56.7055ZM151.216 55.9775C149.406 55.8527 147.254 55.7175 144.976 55.6759C144.873 55.6732 144.775 55.6304 144.703 55.5565C144.631 55.4827 144.591 55.3837 144.591 55.2807C144.591 55.2293 144.601 55.1784 144.621 55.131C144.641 55.0836 144.671 55.0407 144.707 55.0049C144.744 54.969 144.788 54.9409 144.836 54.9221C144.884 54.9034 144.935 54.8945 144.986 54.8959C147.285 54.9479 149.458 55.0727 151.226 55.1975C151.278 55.2001 151.328 55.213 151.375 55.2355C151.421 55.258 151.462 55.2896 151.496 55.3284C151.53 55.3672 151.556 55.4124 151.572 55.4614C151.588 55.5104 151.595 55.5621 151.59 55.6135C151.598 55.7074 151.572 55.8009 151.516 55.8772C151.461 55.9535 151.38 56.0075 151.289 56.0295L151.216 55.9775Z",
    fill: "url(#paint31_linear_405_3876)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6823 119.615C61.6126 119.616 61.5438 119.599 61.4833 119.564C61.4229 119.529 61.373 119.478 61.3391 119.418C60.8132 118.504 60.3443 117.56 59.9351 116.589C59.9147 116.542 59.9039 116.491 59.9033 116.44C59.9028 116.388 59.9125 116.338 59.9319 116.29C59.9512 116.243 59.9799 116.2 60.0162 116.163C60.0525 116.127 60.0956 116.098 60.1431 116.079C60.2384 116.041 60.3449 116.041 60.4401 116.08C60.5352 116.119 60.6115 116.193 60.6527 116.287C61.0543 117.227 61.5092 118.144 62.0151 119.033C62.054 119.091 62.0759 119.158 62.0784 119.228C62.0809 119.298 62.0639 119.367 62.0293 119.427C61.9947 119.488 61.9439 119.537 61.8826 119.571C61.8213 119.604 61.7519 119.619 61.6823 119.615Z",
    fill: "url(#paint32_linear_405_3876)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M187.991 201.817H148.513V209.908H187.991V201.817Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.991 201.817H148.513V209.908H187.991V201.817Z",
    fill: "black"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M165.142 201.817H148.513V209.908H165.142V201.817Z",
    fill: "black"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.513 202.981H183.654L148.513 203.98V202.981Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.992 204.385L157.53 205.145H187.992V204.385Z",
    fill: "black"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.125 206.653L165.143 206.039L187.222 206.653L165.143 206.996L150.125 206.653Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.513 208.369H174.533L148.513 208.982V208.369Z",
    fill: "black"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.929 208.982L170.55 209.305H187.991L187.929 208.982Z",
    fill: "black"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 193.726H143.022V201.817H182.5V193.726Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.5 193.726H143.022V201.817H182.5V193.726Z",
    fill: "black"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.652 193.726H143.022V201.817H159.652V193.726Z",
    fill: "black"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.022 194.89H178.164L143.022 195.878V194.89Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.5 196.294L152.039 197.054H182.5V196.294Z",
    fill: "black"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.624 198.562L159.641 197.938L181.72 198.562L159.641 198.905L144.624 198.562Z",
    fill: "black"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.022 200.267H169.043L143.022 200.891V200.267Z",
    fill: "black"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.438 200.891L165.06 201.214H182.5L182.438 200.891Z",
    fill: "black"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M187.004 185.624H147.525V193.715H187.004V185.624Z",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.004 185.624H147.525V193.715H187.004V185.624Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.155 185.624H147.525V193.715H164.155V185.624Z",
    fill: "black"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.525 186.789H182.667L147.525 187.787V186.789Z",
    fill: "black"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.004 188.193L156.542 188.952H187.004V188.193Z",
    fill: "black"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.137 190.46L164.154 189.846L186.234 190.46L164.154 190.803L149.137 190.46Z",
    fill: "black"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.525 192.176H173.546L147.525 192.79V192.176Z",
    fill: "black"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M186.951 192.79L169.573 193.112H187.003L186.951 192.79Z",
    fill: "black"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M213.305 209.742L214.324 205.862H256.507L275.924 207.807L276.662 209.742H213.305Z",
    fill: "#263238"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M256.507 205.862V209.742H213.305L214.324 205.862H256.507Z",
    fill: "black"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M248.031 187.298C248.087 187.769 248.042 188.246 247.899 188.697C247.756 189.149 247.518 189.564 247.2 189.916C246.883 190.268 246.494 190.548 246.06 190.736C245.625 190.925 245.156 191.019 244.682 191.011H180.077C179.067 190.989 178.099 190.6 177.355 189.917C176.61 189.234 176.14 188.303 176.031 187.298L172.194 145.938C172.152 145.534 172.181 145.126 172.277 144.731C172.456 144.005 172.877 143.361 173.471 142.906C174.064 142.45 174.795 142.21 175.543 142.225H240.189C241.199 142.247 242.167 142.636 242.911 143.319C243.656 144.002 244.126 144.933 244.235 145.938L248.031 187.298Z",
    fill: "#263238"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M244.453 191.011H180.077C179.067 190.989 178.099 190.6 177.355 189.917C176.61 189.234 176.14 188.303 176.031 187.298L172.194 145.937C172.152 145.533 172.181 145.125 172.277 144.731H236.653C237.663 144.753 238.631 145.142 239.376 145.825C240.12 146.508 240.59 147.439 240.699 148.444L244.536 189.805C244.578 190.208 244.55 190.617 244.453 191.011Z",
    fill: "black"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M200.066 165.646H213.43L209.873 203.907L231.006 207.079V209.742H186.494V207.079L195.615 203.907L200.066 165.646Z",
    fill: "#263238"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M213.429 165.646L203.529 209.138L195.614 208.899L200.065 165.646H213.429Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M213.367 376.568H207.003L195.552 217.188H204.007L213.367 376.568Z",
    fill: "#263238"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M213.378 376.568H207.003L196.114 225.113L195.552 217.448H204.007L204.465 225.113L213.378 376.568Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204.465 224.728H196.114L195.552 217.448H204.007L204.465 224.728Z",
    fill: "black"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M260.126 376.568H253.761L252.721 217.188H261.166L260.126 376.568Z",
    fill: "#263238"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261.176 217.448L261.01 243.167L260.136 376.568H253.761L252.888 243.167L252.721 217.448H261.176Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.176 217.448L261.01 243.448H252.888L252.721 217.448H261.176Z",
    fill: "black"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M327.767 376.568H321.403L309.952 217.188H318.407L327.767 376.568Z",
    fill: "#263238"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M327.778 376.568H321.403L310.514 225.113L309.952 217.448H318.407L318.865 225.113L327.778 376.568Z",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M318.865 224.728H310.514L309.952 217.448H318.407L318.865 224.728Z",
    fill: "black"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M140.484 376.568H134.12L143.48 217.188H151.935L140.484 376.568Z",
    fill: "#263238"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M151.935 217.448L151.373 225.113L140.484 376.568H134.12L143.022 225.113L143.48 217.448H151.935Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.48 217.448H151.935L151.373 224.728H143.022L143.48 217.448Z",
    fill: "black"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M136.782 213.215H325.105V218.946C325.105 219.241 325.047 219.533 324.934 219.805C324.822 220.078 324.656 220.325 324.447 220.534C324.239 220.743 323.991 220.908 323.719 221.021C323.446 221.134 323.154 221.192 322.859 221.192H139.029C138.433 221.192 137.861 220.955 137.44 220.534C137.019 220.113 136.782 219.541 136.782 218.946V213.215Z",
    fill: "url(#paint33_linear_405_3876)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M136.782 213.215H325.105V218.946C325.105 219.241 325.047 219.533 324.934 219.805C324.822 220.078 324.656 220.325 324.447 220.534C324.239 220.743 323.991 220.908 323.719 221.021C323.446 221.134 323.154 221.192 322.859 221.192H139.029C138.433 221.192 137.861 220.955 137.44 220.534C137.019 220.113 136.782 219.541 136.782 218.946V213.215Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.105 213.205H136.782V217.198H325.105V213.205Z",
    fill: "black"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M329.057 214.255H132.83C132.234 214.255 131.663 214.018 131.241 213.597C130.82 213.176 130.583 212.605 130.583 212.009C130.583 211.412 130.82 210.84 131.241 210.417C131.662 209.994 132.233 209.755 132.83 209.752H329.057C329.654 209.755 330.225 209.994 330.646 210.417C331.067 210.84 331.303 211.412 331.303 212.009C331.303 212.605 331.067 213.176 330.646 213.597C330.224 214.018 329.653 214.255 329.057 214.255Z",
    fill: "url(#paint34_linear_405_3876)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M329.057 214.255H132.83C132.234 214.255 131.663 214.018 131.241 213.597C130.82 213.176 130.583 212.605 130.583 212.009C130.583 211.412 130.82 210.84 131.241 210.417C131.662 209.994 132.233 209.755 132.83 209.752H329.057C329.654 209.755 330.225 209.994 330.646 210.417C331.067 210.84 331.303 211.412 331.303 212.009C331.303 212.605 331.067 213.176 330.646 213.597C330.224 214.018 329.653 214.255 329.057 214.255Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M282.631 202.815L285.044 199.196C285.282 198.84 285.604 198.549 285.981 198.348C286.358 198.146 286.78 198.041 287.207 198.042H290.265C290.519 198.042 290.771 198.081 291.014 198.156L301.923 201.463C302.543 201.648 303.071 202.06 303.4 202.618L304.971 205.249L282.631 202.815Z",
    fill: "url(#paint35_linear_405_3876)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M304.97 205.249L289.069 203.522L282.61 202.815L285.023 199.196C285.261 198.84 285.583 198.549 285.96 198.348C286.337 198.146 286.759 198.041 287.186 198.042H290.244C290.501 198.043 290.757 198.082 291.003 198.156L291.242 198.229L301.902 201.463C302.526 201.647 303.057 202.059 303.39 202.618L304.97 205.249Z",
    fill: "black"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M304.971 205.249L289.069 203.522L291.243 198.229L301.903 201.463C302.526 201.647 303.058 202.059 303.39 202.618L304.971 205.249Z",
    fill: "black"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M312.521 209.398V209.742H278.804L280.052 204.864C280.283 203.968 280.807 203.175 281.54 202.61C282.272 202.045 283.173 201.74 284.098 201.744H299.053C299.55 201.742 300.043 201.83 300.509 202.004L302.381 202.701L309.807 205.467C310.608 205.764 311.299 206.301 311.784 207.004C312.27 207.708 312.527 208.544 312.521 209.398Z",
    fill: "url(#paint36_linear_405_3876)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M312.521 209.398V209.742H298.679L299.417 204.469C299.465 204.142 299.585 203.83 299.769 203.555C299.952 203.281 300.195 203.051 300.479 202.882C300.764 202.714 301.082 202.611 301.411 202.581C301.74 202.552 302.071 202.596 302.381 202.711L309.807 205.477C310.607 205.774 311.296 206.309 311.781 207.01C312.267 207.712 312.525 208.545 312.521 209.398Z",
    fill: "black"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M300.832 206.164L305.241 192.946C305.284 192.811 305.356 192.687 305.452 192.583C305.548 192.479 305.666 192.398 305.796 192.344C305.927 192.291 306.068 192.266 306.21 192.273C306.351 192.28 306.489 192.318 306.614 192.384C306.806 192.494 306.957 192.662 307.047 192.864C307.137 193.066 307.16 193.291 307.113 193.507L303.4 207.61C303.4 207.61 300.936 208.608 300.832 206.164Z",
    fill: "#263238"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.631 208.65H280.676L281.051 206.726H283.006L282.631 208.65Z",
    fill: "black"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M285.543 208.577H283.588L283.962 206.653H285.917L285.543 208.577Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_405_3876",
    x1: 317.974,
    y1: 59.4139,
    x2: 368.886,
    y2: 41.3693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_405_3876",
    x1: 336.129,
    y1: 31.2157,
    x2: 349.054,
    y2: 30.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_405_3876",
    x1: 409.5,
    y1: 376.568,
    x2: 449.542,
    y2: 371.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_405_3876",
    x1: 447.741,
    y1: 339.929,
    x2: 415.183,
    y2: 359.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_405_3876",
    x1: 264.409,
    y1: 182.982,
    x2: 319.351,
    y2: 177.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_405_3876",
    x1: 263.858,
    y1: 133.832,
    x2: 274.97,
    y2: 131.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_405_3876",
    x1: 248.31,
    y1: 323.528,
    x2: 375.048,
    y2: 307.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_405_3876",
    x1: 247.301,
    y1: 324.682,
    x2: 262.85,
    y2: 322.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_405_3876",
    x1: 275.213,
    y1: 347.292,
    x2: 343.155,
    y2: 342.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_405_3876",
    x1: 296.587,
    y1: 349.507,
    x2: 311.209,
    y2: 346.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_405_3876",
    x1: 343.012,
    y1: 219.193,
    x2: 341.135,
    y2: 219.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_405_3876",
    x1: 321.956,
    y1: 220.101,
    x2: 320.079,
    y2: 220.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_405_3876",
    x1: 311.647,
    y1: 221.4,
    x2: 362.327,
    y2: 216.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_405_3876",
    x1: 336.608,
    y1: 154.134,
    x2: 347.504,
    y2: 153.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_405_3876",
    x1: 338.51,
    y1: 146.603,
    x2: 347.546,
    y2: 146.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_405_3876",
    x1: 326.924,
    y1: 154.764,
    x2: 340.535,
    y2: 149.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_405_3876",
    x1: 339.467,
    y1: 152.312,
    x2: 346.659,
    y2: 151.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_405_3876",
    x1: 324.75,
    y1: 154.983,
    x2: 328.118,
    y2: 154.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_405_3876",
    x1: 331.636,
    y1: 178.729,
    x2: 343.813,
    y2: 177.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_405_3876",
    x1: 324.688,
    y1: 177.761,
    x2: 330.431,
    y2: 177.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_405_3876",
    x1: 331.482,
    y1: 204.717,
    x2: 363.37,
    y2: 202.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_405_3876",
    x1: 335.109,
    y1: 165.219,
    x2: 345.646,
    y2: 162.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_405_3876",
    x1: 233.054,
    y1: 351.951,
    x2: 254.509,
    y2: 349.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_405_3876",
    x1: 293.767,
    y1: 376.566,
    x2: 312.774,
    y2: 374.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_405_3876",
    x1: 357.48,
    y1: 132.324,
    x2: 407.522,
    y2: 122.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_405_3876",
    x1: 359.092,
    y1: 144.222,
    x2: 378.345,
    y2: 141.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_405_3876",
    x1: 214.53,
    y1: 84.4805,
    x2: 250.802,
    y2: 80.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_405_3876",
    x1: 233.095,
    y1: 83.4625,
    x2: 239.588,
    y2: 82.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_405_3876",
    x1: 189.613,
    y1: 92.9714,
    x2: 239.724,
    y2: 84.3661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_405_3876",
    x1: 177.223,
    y1: 86.264,
    x2: 216.626,
    y2: 80.0758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_405_3876",
    x1: 169.399,
    y1: 60.2312,
    x2: 173.356,
    y2: 59.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_405_3876",
    x1: 64.9712,
    y1: 144.575,
    x2: 173.357,
    y2: 131.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_405_3876",
    x1: 59.9033,
    y1: 119.616,
    x2: 62.3057,
    y2: 119.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_405_3876",
    x1: 136.782,
    y1: 221.192,
    x2: 164.073,
    y2: 150.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_405_3876",
    x1: 130.583,
    y1: 214.255,
    x2: 139.59,
    y2: 170.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_405_3876",
    x1: 282.631,
    y1: 205.249,
    x2: 304.862,
    y2: 197.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_405_3876",
    x1: 278.804,
    y1: 209.742,
    x2: 309.658,
    y2: 195.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingContact);
export default __webpack_public_path__ + "static/media/Training-Contact.80df8b28368b90439c058a902725543c.svg";
export { ForwardRef as ReactComponent };